
const translations = {
    "Notice!": "Notiz!",
    "Are you sure that you want to delete this?": "Sind Sie sicher, dass Sie dies löschen möchten?",
    "Confirm": "Bestätigen",
    "Cancel": "Stornieren",
    "Min": "Mindest",
    "Max": "Max",
    "Before": "Vor",
    "After": "Nach",
    "w": "In",
    "week": "Woche",
    "weeks": "Wochen",
    "d": "D",
    "day": "Tag",
    "days": "Tage",
    "Due date": "Geburtstermin",
    "Start date": "Startdatum",
    "Internal date": "Interner Termin",
    "Notes": "Anmerkungen",
    "Document": "Dokumentieren",
    "Email": "Email",
    "Billing": "Abrechnung",
    "Add": "Hinzufügen",
    "Archived": "Archiviert",
    "Cancelled": "Abgesagt",
    "Active": "Aktiv",
    "Inactive": "Inaktiv",
    "Client company": "Kundenunternehmen",
    "General info": "Allgemeine Information",
    "Digitisation of client documents": "Digitalisierung von Kundendokumenten",
    "Client portal": "Kundenportal",
    "Documents": "Unterlagen",
    "Members": "Mitglieder",
    "Preferences": "Präferenzen",
    "Yes": "Ja",
    "No": "NEIN",
    "Total hours": "Gesamtstunden",
    "Extra hours": "Extrastunden",
    "Client": "Klient",
    "Tasks": "Aufgaben",
    "Disable Uku’s task templates": "Deaktivieren Sie Ukus Aufgabenvorlagen",
    "Set the estimation as time when the exact value is not entered": "Legen Sie die Schätzung als Zeitpunkt fest, wenn der genaue Wert nicht eingegeben wird",
    "Checklist must be completed to finish the task": "Um die Aufgabe abzuschließen, muss die Checkliste ausgefüllt werden",
    "Disable topic management for members": "Deaktivieren Sie die Themenverwaltung für Mitglieder",
    "Disable time edit for members": "Zeitbearbeitung für Mitglieder deaktivieren",
    "Allow time entries in future": "Zeiteinträge in Zukunft zulassen",
    "Show all dependent tasks in the calendar": "Show all dependent tasks in the calendar",
    "Clients": "Kunden",
    "Disable adding new clients for members": "Deaktivieren Sie das Hinzufügen neuer Kunden für Mitglieder",
    "Only administrators can edit documents": "Nur Administratoren können Dokumente bearbeiten",
    "Allow digitisation of client documents": "Die Digitalisierung von Kundendokumenten ermöglichen",
    "Use my Microsoft account": "Verwenden Sie mein Microsoft-Konto",
    "Disconnect my Microsoft account": "Trennen Sie mein Microsoft-Konto",
    "Connect my Microsoft account": "Verbinden Sie mein Microsoft-Konto",
    "Use my google account": "Benutze meinen Google Account",
    "Connect my google account": "Verbinde mein Google-Konto",
    "Disconnect my google account": "Trennen Sie mein Google-Konto",
    "Emails": "E-Mails",
    "Daily agenda": "Tagesordnung",
    "Unread notifications": "Ungelesene Benachrichtigungen",
    "Task assigned to me": "Mir zugewiesene Aufgabe",
    "Weekly summary": "Wöchentliche Zusammenfassung",
    "Monthly summary": "Monatliche Zusammenfassung",
    "Updates and tips": "Updates und Tipps",
    "Overdue": "Überfällig",
    "1 day": "1 Tag",
    "1 day overdue": "1 Tag überfällig",
    "{0} days": "{0} Tage",
    "{0} days overdue": "{0} Tage überfällig",
    "{0} minute ago": "{0} vor einer Minute",
    "{0} minutes ago": "vor {0} Minuten",
    "{0} hour ago": "vor {0} Stunde",
    "{0} hours ago": "vor {0} Stunden",
    "Sunday": "Sonntag",
    "Monday": "Montag",
    "Tuesday": "Dienstag",
    "Wednesday": "Mittwoch",
    "Thursday": "Donnerstag",
    "Friday": "Freitag",
    "Saturday": "Samstag",
    "Sun": "Sonne",
    "Mon": "Mein",
    "Tue": "Di",
    "Wed": "Heiraten",
    "Thu": "Sammeln",
    "Fri": "Fr",
    "Sat": "Sa",
    "January": "Januar",
    "February": "Februar",
    "March": "Marsch",
    "April": "April",
    "May": "Dürfen",
    "June": "Juni",
    "July": "Juli",
    "August": "August",
    "September": "September",
    "October": "Oktober",
    "November": "November",
    "December": "Dezember",
    "Jan": "Jan",
    "Feb": "Febr",
    "Mar": "Beschädigen",
    "Apr": "Apr",
    "Jun": "Jun",
    "Jul": "Juli",
    "Aug": "Aug",
    "Sep": "Sept",
    "Oct": "Okt",
    "Nov": "Nov",
    "Dec": "Dez",
    "Today": "Heute",
    "Yesterday": "Gestern",
    "Day": "Tag",
    "Days": "Tage",
    "+{0} d": "+{0} d",
    "+{0} wd": "+{0} wd",
    "Weekly {0}": "Wöchentlich {0}",
    "Every {0}. week {1}": "Alle {0}. Woche 1}",
    "{0}": "{0}",
    "Monthly {0}. d": "Monatlich {0}. D",
    "Every {0}. month {1}. d": "Alle {0}. Monat {1}. D",
    "{0}. d": "{0}. D",
    "Quarterly {0}. month {1}. d": "Vierteljährlich {0}. Monat {1}. D",
    "Every {0}. quarter {1}. month {2}. d": "Alle {0}. Viertel 1}. Monat {2}. D",
    "{0}. month {1}. d": "{0}. Monat {1}. D",
    "Yearly {0}": "Jährlich {0}",
    "Every {0}. year {1}": "Alle {0}. Jahr 1}",
    "Mo": "Mo",
    "Tu": "Das",
    "We": "Wir",
    "Th": "Th",
    "Fr": "Fr",
    "Sa": "An",
    "Su": "Sie sind",
    "and": "Und",
    "{0}w": "{0}w",
    "{0}d": "{0}d",
    "before": "Vor",
    "after": "nach",
    "Project": "Projekt",
    "Quarter": "Quartal",
    "Add your photo": "Fügen Sie Ihr Foto hinzu",
    "Adding file failed": "Das Hinzufügen der Datei ist fehlgeschlagen",
    "Please check the file.": "Bitte überprüfen Sie die Datei.",
    "You can only add pictures.": "Sie können nur Bilder hinzufügen.",
    "Error": "Fehler",
    "Create new topic": "Neues Thema erstellen",
    "Name": "Name",
    "Close": "Schließen",
    "Find topic...": "Thema finden...",
    "New topic": "Neues Thema",
    "Invalid format": "Ungültiges Format",
    "Demo company account": "Demo-Firmenkonto",
    "Demo account will be deleted later. Do this for testing purposes only!": "Das Demokonto wird später gelöscht. Tun Sie dies nur zu Testzwecken!",
    "Subscribe": "Abonnieren",
    "Start demo": "Demo starten",
    "End demo": "Demo beenden",
    "Free trial is expired - {0}": "Kostenlose Testversion ist abgelaufen – {0}",
    "Free trial {1} {2} left - {0}": "Kostenlose Testversion {1} {2} übrig – {0}",
    "Add time": "Zeit hinzufügen",
    "Billable": "Abrechnungsfähig",
    "Date": "Datum",
    "Start": "Start",
    "End": "Ende",
    "Duration": "Dauer",
    "Split duration equally": "Dauer gleichmäßig aufteilen",
    "Required field": "Pflichtfeld",
    "Members list": "Mitgliederliste",
    "Edit fields": "Felder bearbeiten",
    "Maximum number of selected columns has been exceeded": "Die maximale Anzahl ausgewählter Spalten wurde überschritten",
    "If you want to add a new column to the report, please remove an existing one first.": "Wenn Sie dem Bericht eine neue Spalte hinzufügen möchten, entfernen Sie bitte zuerst eine vorhandene Spalte.",
    "Snooze until...": "Schlummern, bis...",
    "Select date & time": "Wählen Sie Datum und Uhrzeit aus",
    "Tomorrow": "Morgen",
    "Later this week": "Später diese Woche",
    "Next week": "Nächste Woche",
    "Add task": "Aufgabe hinzufügen",
    "Checklist": "Checkliste",
    "Start timer": "Timer starten",
    "Add an item": "Fügen Sie einen Artikel hinzu",
    "Add checklist item": "Checklistenpunkt hinzufügen",
    "Convert to a task": "In eine Aufgabe umwandeln",
    "Delete": "Löschen",
    "Delegate to...": "Delegieren Sie an...",
    "Please select tasks from the same account": "Bitte wählen Sie Aufgaben aus demselben Konto aus",
    "Follow": "Folgen",
    "Expand sidebar": "Seitenleiste ausklappen",
    "Nicely done!": "Schön gemacht!",
    "You've finished all your tasks, take a second to recharge": "Sie haben alle Ihre Aufgaben erledigt. Nehmen Sie sich eine Sekunde Zeit, um neue Energie zu tanken",
    "Search tasks...": "Suchaufgaben...",
    "Search": "Suchen",
    "select/unselect all": "Alle auswählen/abwählen",
    "Add new client": "Neuen Kunden hinzufügen",
    "Account": "Konto",
    "Client name": "Kundenname",
    "Select client": "Wählen Sie den Kunden aus",
    "New client": "Neuer Kunde",
    "Must be an integer": "Muss eine ganze Zahl sein",
    "Must be a number": "Muss eine Nummer sein",
    "Dashboard": "Dashboard",
    "Calendar": "Kalender",
    "Report": "Bericht",
    "Monitoring": "Überwachung",
    "Suppliers": "Lieferanten",
    "Events": "Veranstaltungen",
    "Projects": "Projekte",
    "Help": "Hilfe",
    "Settings & Apps": "Einstellungen und Apps",
    "Profile": "Profil",
    "Collapse menu": "Menü einklappen",
    "Expand menu": "Menü erweitern",
    "Are you sure to delete this attachment?": "Möchten Sie diesen Anhang wirklich löschen?",
    "Select": "Wählen",
    "Edit contacts": "Kontakte bearbeiten",
    "Add member": "Mitglied hinzufügen",
    "Add note": "Notiz hinzufügen",
    "Open": "Open",
    "Reports": "Berichte",
    "Billing notes": "Anmerkungen zur Rechnung",
    "Pinned notes": "Angepinnte Notizen",
    "Sub-companies": "Untergesellschaften",
    "Contacts": "Kontakte",
    "Event info": "Event Info",
    "Project info": "Projektinformationen",
    "Summary": "Zusammenfassung",
    "Task": "Aufgabe",
    "Time": "Zeit",
    "Collapse sidebar": "Seitenleiste einklappen",
    "Client Overview": "Kundenübersicht",
    "Event Overview": "Event Übersicht",
    "Project Overview": "Projektübersicht",
    "Edit client": "Kunde bearbeiten",
    "Edit event": "Veranstaltung bearbeiten",
    "Edit project": "Projekt bearbeiten",
    "Show all": "Zeige alles",
    "Collapse": "Zusammenbruch",
    "by": "von",
    "View all": "Alle ansehen",
    "Add company event": "Unternehmensveranstaltung hinzufügen",
    "Company": "Unternehmen",
    "Info": "Die Info",
    "Holiday": "Feiertag",
    "All day(s)": "Ganzer Tag(e)",
    "End date": "Endtermin",
    "From": "Von",
    "Until": "Bis",
    "Hours": "Std",
    "Link": "Verknüpfung",
    "Save": "Speichern",
    "Are you sure that you want to delete this company calendar event?": "Bist du sicher, dass du diesen Termin im Unternehmenskalender löschen möchtest?",
    "Location of client folder in your document management system": "Location of client folder in your document management system",
    "Defined main folder": "Defined main folder",
    "Custom folder": "Custom folder",
    "Add new role": "Neue Rolle hinzufügen",
    "New role": "Neue Rolle",
    "Access enabled": "Zugriff aktiviert",
    "Waiting for files": "Warten auf Dateien",
    "Uploaded": "Hochgeladen",
    "Uploading...": "Hochladen...",
    "Client members": "Kundenmitglieder",
    "Email settings": "Email Einstellungen",
    "Or connect new email address": "Oder verbinden Sie eine neue E-Mail-Adresse",
    "Connect with Microsoft Exchange or other email server (SMTP)": "Verbinden Sie sich mit Microsoft Exchange oder einem anderen E-Mail-Server (SMTP).",
    "Test email sent": "Test-E-Mail gesendet",
    "Email address": "E-Mail-Addresse",
    "Reply address": "Antwortadresse",
    "Sender name": "Absender",
    "Who can use?": "Wer kann es nutzen?",
    "Client default address": "Standardadresse des Clients",
    "Invalid e-mail": "Ungültige E-Mail",
    "Role": "Rolle",
    "E-mail": "Email",
    "Mobile phone": "Mobiltelefon",
    "Work phone": "Arbeitshandy",
    "Language": "Sprache",
    "Birthday": "Geburtstag",
    "Are you sure to delete this contact?": "Möchten Sie diesen Kontakt wirklich löschen?",
    "Manage contact fields": "Kontaktfelder verwalten",
    "Administrative Assistant": "Administrative Assistent",
    "Board member": "Vorstandsmitglied",
    "CEO": "CEO",
    "Add contact": "Kontakt hinzufügen",
    "Contact person": "Ansprechpartner",
    "Leave page?": "Seite verlassen?",
    "Changes that you made may not be saved": "Von Ihnen vorgenommene Änderungen werden möglicherweise nicht gespeichert",
    "Leave": "Verlassen",
    "Super! We're importing your clients...": "Super! Wir importieren Ihre Kunden...",
    "Feel free to leave this page. We will pop up a notification when the import is prepared. Then you need to confirm the clients you want to add to Uku.": "Sie können diese Seite gerne verlassen. Wir werden eine Benachrichtigung anzeigen, wenn der Import vorbereitet ist. Anschließend müssen Sie die Clients bestätigen, die Sie zu Uku hinzufügen möchten.",
    "Please wait...": "Warten Sie mal...",
    "Setup API keys": "API-Schlüssel einrichten",
    "You have two options": "Sie haben zwei Möglichkeiten",
    "how to setup API keys": "wie man API-Schlüssel einrichtet",
    "Continue": "Weitermachen",
    "Custom import": "Benutzerdefinierter Import",
    "To import clients and volume of work from !INTEGRATION, Uku needs !INTEGRATION API key for every client.": "Um Kunden und Arbeitsvolumen aus !INTEGRATION zu importieren, benötigt Uku für jeden Kunden einen !INTEGRATION-API-Schlüssel.",
    "1. <span class=font-weight-medium>Continue</span> - Uku automatically creates API keys for every client": "1. <span class=font-weight-medium>Weiter</span> – Uku erstellt automatisch API-Schlüssel für jeden Client",
    "1. <span class=font-weight-medium>Custom import</span> - Uku connects only with existing UKU API keys. Create API keys manually in !INTEGRATION before import. Read:": "1. <span class=font-weight-medium>Benutzerdefinierter Import</span> – Uku stellt nur eine Verbindung mit vorhandenen UKU-API-Schlüsseln her. Erstellen Sie API-Schlüssel vor dem Import manuell in !INTEGRATION. Lesen:",
    "(it takes a lot of time)": "(es benötigt viel Zeit)",
    "Import Clients": "Kunden importieren",
    "Country": "Land",
    "Please choose your country": "Bitte wählen Sie Ihr Land",
    "Password": "Passwort",
    "Start import": "Import starten",
    "Insert !INTEGRATION login details (it’s secure) to give one time access to import clients and API keys. Please note that you will get logged out from !INTEGRATION in other browsers.": "Geben Sie die Anmeldedaten von !INTEGRATION ein (es ist sicher), um einmaligen Zugriff auf Import-Clients und API-Schlüssel zu gewähren. Bitte beachten Sie, dass Sie in anderen Browsern von !INTEGRATION abgemeldet werden.",
    "Update invoice status": "Rechnungsstatus aktualisieren",
    "Update now": "Jetzt aktualisieren",
    "Daily @ 14:00": "Täglich um 14:00 Uhr",
    "Daily @ 18:00": "Täglich um 18:00 Uhr",
    "Updating invoice statuses, please wait...": "Rechnungsstatus wird aktualisiert, bitte warten...",
    "Your import is ready": "Ihr Import ist fertig",
    "In the final step you need to confirm the clients you want to add to uku": "Im letzten Schritt müssen Sie die Kunden bestätigen, die Sie zu uku hinzufügen möchten",
    "Let's go": "Lass uns gehen",
    "Import again": "Erneut importieren",
    "Do you have new clients to import?": "Müssen Sie neue Kunden importieren?",
    "Yes, i do": "Ja, ich will",
    "View last import": "Letzten Import anzeigen",
    "Email server": "E-Mail-Server",
    "Email provider": "E-Mail-Anbieter",
    "Host": "Gastgeber",
    "Port": "Hafen",
    "Security": "Sicherheit",
    "Sender email": "Absender E-Mail",
    "Username": "Nutzername",
    "Test connection": "Testverbindung",
    "How to set up": "Wie stellt man das ein",
    "Only administrators can activate the app": "Nur Administratoren können die App aktivieren",
    "You are in the waiting list": "Sie stehen auf der Warteliste",
    "We onboard all applicants one by one": "Markieren Sie Ihr Interesse, und wir benachrichtigen Sie, wenn die App zum Testen verfügbar ist",
    "Connected": "Verbunden",
    "Activated": "Aktiviert",
    "Join waiting list": "Interesse markieren",
    "Activate": "aktivieren Sie",
    "Unsubscribe from waiting list": "Von der Warteliste abmelden",
    "Deactivate app": "App deaktivieren",
    "Disconnect": "Trennen",
    "Hide expanded content": "Hide expanded content",
    "Show trimmed content": "Show trimmed content",
    "Email not delivered": "E-Mail nicht zugestellt",
    "Sent, but fallback to Uku email": "Gesendet, aber Rückgriff auf Uku-E-Mail",
    "Unknown error": "Unbekannter Fehler",
    "to": "Zu",
    "in any minute": "in jeder Minute",
    "on {0},": "am {0},",
    "or": "oder",
    "Send now": "Schick jetzt",
    "Uku <span class='subtitle-2'>is sending</span> email": "Uku <span class='subtitle-2'>sendet</span> E-Mail",
    "__From_email": "Von",
    "Set up email": "E-Mail einrichten",
    "Client default": "Client-Standard",
    "Subject": "Thema",
    "Edit email": "E-Mail bearbeiten",
    "Template": "Vorlage",
    "Cc": "CC",
    "Bcc": "Bcc",
    "__To_email": "An",
    "__Cc_email": "Cc",
    "__Bcc_email": "Bcc",
    "Add template": "Vorlage hinzufügen",
    "Add automation": "Fügen Sie Automatisierung hinzu",
    "Add placeholder": "Platzhalter hinzufügen",
    "Format text": "Text formatieren",
    "Add attachment": "Anhang hinzufügen",
    "Send": "Schicken",
    "Save automation": "Automatisierung speichern",
    "Choose email template": "Wählen Sie eine E-Mail-Vorlage",
    "All languages": "Alle Sprachen",
    "No templates found.": "Keine Vorlagen gefunden.",
    "Edit email template": "E-Mail-Vorlage bearbeiten",
    "Are you sure you want to delete this template? Some tasks will be affected": "Sind Sie sicher, dass Sie diese Vorlage löschen möchten? Einige Aufgaben werden davon betroffen sein",
    "Are you sure you want to delete this template?": "Sind Sie sicher, dass Sie diese Vorlage löschen möchten?",
    "Are you sure you want to save this template, the following tasks will be affected?": "Sind Sie sicher, dass Sie diese Vorlage speichern möchten? Die folgenden Aufgaben sind davon betroffen?",
    "Template name": "Vorlagenname",
    "Edit template": "Vorlage bearbeiten",
    "Send email": "E-Mail senden",
    "on": "An",
    "Ok": "OK",
    "Supplier": "Anbieter",
    "Event": "Veranstaltung",
    "Contact": "Kontakt",
    "Validation failed": "Überprüfung fehlgeschlagen",
    "Saving supplier failed": "Speichern des Lieferanten ist fehlgeschlagen",
    "Saving client failed": "Speichern des Clients ist fehlgeschlagen",
    "Saving project failed": "Speichern des Projekts ist fehlgeschlagen",
    "several values": "mehrere Werte",
    "values": "Werte",
    "is": "Ist",
    "Add filter": "Filter hinzufügen",
    "Update": "Aktualisieren",
    "forever": "für immer",
    "Last week": "Letzte Woche",
    "This week": "Diese Woche",
    "Last month": "Im vergangenen Monat",
    "This month": "Diesen Monat",
    "Next month": "Nächsten Monat",
    "Last year": "Letztes Jahr",
    "This year": "Dieses Jahr",
    "This quarter": "Dieses Quartal",
    "Next quarter": "Nächstes Quartal",
    "Last quarter": "Letztes Quartal",
    "Client group": "Kundengruppe",
    "Topic": "Thema",
    "Member": "Mitglied",
    "Primary member": "Hauptmitglied",
    "Client status": "Kundenstatus",
    "Active clients": "Aktive Kunden",
    "Inactive clients": "Inaktive Kunden",
    "All": "Alle",
    "Project status": "Projekt-Status",
    "Member status": "Mitgliedsstatus",
    "Active members": "Aktive Mitglieder",
    "Limited members": "Begrenzte Mitglieder",
    "Inactive members": "Inaktive Mitglieder",
    "Contract status": "Vertragsstatus",
    "Active contracts": "Aktive Verträge",
    "Pending contracts": "Ausstehende Verträge",
    "Finished contracts": "Abgeschlossene Verträge",
    "Contract template": "Vertragsvorlage",
    "Payment recurrence": "Zahlungswiederholung",
    "Yearly": "Jährlich",
    "Monthly": "Monatlich",
    "Trial": "Gerichtsverhandlung",
    "Region": "Region",
    "Field": "Feld",
    "All tasks": "Alle Aufgaben",
    "Todo": "alle",
    "Not done": "Nicht durchgeführt",
    "Done": "Erledigt",
    "Delayed": "Verzögert",
    "Important": "Wichtig",
    "Extra work": "Extra Arbeit",
    "I Follow": "Ich folge",
    "Commented": "Kommentiert",
    "Tracked time": "Verfolgte Zeit",
    "Estimated": "Geschätzt",
    "Recurring task": "Wiederkehrende Aufgabe",
    "Last import": "Letzter Import",
    "Period": "Zeitraum",
    "Client search": "Kundensuche",
    "Voucher": "Gutschein",
    "Company status": "Betriebsstatus",
    "Deleted": "Gelöscht",
    "All status": "Jeden Status",
    "Payment gateway": "Zahlungsart / Bezahl-Gateway",
    "All gateways": "Alle Gateways",
    "Uku manually": "Uku manuell",
    "Braintree": "Braintree",
    "Plan status": "Planstatus",
    "All plans": "Alle Pläne",
    "Paid": "Bezahlt",
    "Paid churn": "Bezahlte Abwanderung",
    "Trial churn": "Abwandern auf Probe",
    "Plan period": "Planperiode",
    "All periods": "Gesamtzeitraum",
    "Monthly plan": "Monatlicher Plan",
    "Yearly plan": "Jahresplan",
    "Company search": "Firmensuche",
    "User search": "Benutzersuche",
    "Name key search": "Namensschlüsselsuche",
    "None filter": "Kein Filter",
    "OK": "OK",
    "Start date cannot be later than due date": "Das Startdatum kann nicht später sein als das Fälligkeitsdatum",
    "tasks": "Aufgaben",
    "task(s) had errors": "Aufgabe(n) hatten Fehler",
    "tasks selected": "Aufgaben ausgewählt",
    "Postpone": "Verschieben",
    "Mark done": "Mark fertig",
    "Hide multiselect": "Mehrfachauswahl ausblenden",
    "Delete task(s)": "Aufgabe(n) löschen",
    "All of the data related to the task will be deleted": "Alle mit der Aufgabe verbundenen Daten werden gelöscht",
    "Some tasks include other people. Are you sure you want to delete?": "Einige Aufgaben umfassen andere Personen. Bist du sicher, dass du sie löschen willst?",
    "Time has been tracked to some of the selected activities. Are you sure you want to delete?": "Für einige der ausgewählten Aktivitäten wurde Zeit aufgezeichnet. Bist du sicher, dass du sie löschen willst?",
    "Time has been tracked to some of the selected activities. Some tasks include other people. Are you sure you want to delete?": "Die Zeit wurde für einige der ausgewählten Aktivitäten erfasst. Einige Aufgaben umfassen andere Personen. Bist du sicher, dass du sie löschen willst?",
    "task(s) were not marked done": "Aufgabe(n) wurden nicht als erledigt markiert",
    "Please check if the checklist has been completed or time is entered and they are assigned to you": "Bitte prüfen Sie, ob die Checkliste ausgefüllt bzw. die Zeit eingetragen ist und diese Ihnen zugeordnet sind",
    "task(s) were not deleted": "Aufgabe(n) wurden nicht gelöscht",
    "task(s) time was not updated": "Die Zeit der Aufgabe(n) wurde nicht aktualisiert",
    "Please make sure that you can add time to task": "Bitte stellen Sie sicher, dass Sie der Aufgabe Zeit hinzufügen können",
    "invoice table row": "Rechnungstabellenzeile",
    "invoice table row(s) had errors": "Die Zeile(n) der Rechnungstabelle wiesen Fehler auf",
    "invoice table row(s) selected": "Rechnungstabellenzeile(n) ausgewählt",
    "Create": "Erstellen",
    "Mark paid": "Mark hat bezahlt",
    "Send to client": "An Kunden senden",
    "Recalculate": "Neu berechnen",
    "Export to {0}": "Exportieren nach {0}",
    "Update Status from {0}": "Status aktualisieren von {0}",
    "Void invoice": "Rechnung stornieren",
    "Delete invoice": "Rechnung löschen",
    "Restore invoice": "Rechnung wiederherstellen",
    "Mark unpaid": "Als unbezahlt markieren",
    "Invoices": "Rechnungen",
    "Download to Excel": "Nach Excel herunterladen",
    "Revenue split": "Aufteilung der Einnahmen",
    "Tax": "Steuer",
    "Description": "Beschreibung",
    "Percent": "Prozent",
    "Integration Id": "Integration Id",
    "Integration Code": "Integration Code",
    "Name on invoice": "Name auf der Rechnung",
    "Restore": "Wiederherstellen",
    "Archive": "Archiv",
    "Hide": "Verstecken",
    "Are you sure?": "Bist du dir sicher?",
    "Import finished!": "Import beendet!",
    "Failed to import {0} records": "{0} Datensätze konnten nicht importiert werden",
    "Download report": "Bericht herunterladen",
    "Result: added {0}, updated {1}, skipped {2}, failed to import {3}": "Ergebnis: {0} hinzugefügt, {1} aktualisiert, {2} übersprungen, {3} konnte nicht importiert werden",
    "Result: added {0}, updated {1}, skipped {2}": "Ergebnis: {0} hinzugefügt, {1} aktualisiert, {2} übersprungen",
    "What’s next?": "Was kommt als nächstes?",
    "To work effectively with your client base, complete the following steps:": "Um effektiv mit Ihrem Kundenstamm zusammenzuarbeiten, führen Sie die folgenden Schritte aus:",
    "Read more ›": "Weiterlesen >",
    "Next you will only see active imported clients. To see all clients, remove “Last import” filter.": "Als nächstes sehen Sie nur aktive importierte Clients. Um alle Clients anzuzeigen, entfernen Sie den Filter „Letzter Import“.",
    "View clients": "Kunden anzeigen",
    "Add <b>primary member</b> to every client.": "Fügen Sie jedem Client <b>primäres Mitglied</b> hinzu.",
    "Add <b>task plan</b> to automate recurring tasks.": "Fügen Sie einen <b>Aufgabenplan</b> hinzu, um wiederkehrende Aufgaben zu automatisieren.",
    "Setup automatic monthly summary under {0} app in Uku to import volume of work.": "Richten Sie unter der {0}-App in Uku eine automatische monatliche Zusammenfassung ein, um das Arbeitsvolumen zu importieren.",
    "Title": "Titel",
    "Field type": "Feldtyp",
    "Field name": "Feldname",
    "Group name": "Gruppenname",
    "Choices": "Auswahlmöglichkeiten",
    "Type each choice on a separate line": "Geben Sie jede Auswahl in eine separate Zeile ein",
    "Required": "Erforderlich",
    "For all topics": "Für alle Themen",
    "For specific topics": "Für bestimmte Themen",
    "Topics": "Themen",
    "Non-billable": "Nicht abrechenbar",
    "Edit task custom field": "Benutzerdefiniertes Aufgabenfeld bearbeiten",
    "Add task custom field": "Benutzerdefiniertes Aufgabenfeld hinzufügen",
    "Edit client custom field": "Benutzerdefiniertes Kundenfeld bearbeiten",
    "Add client custom field": "Benutzerdefiniertes Kundenfeld hinzufügen",
    "Choice {0}": "Auswahl {0}",
    "Are you sure that you want to delete this custom field?": "Sind Sie sicher, dass Sie dieses benutzerdefinierte Feld löschen möchten?",
    "Warning!": "Warnung!",
    "This custom field is in use. Do you wish to archive it?": "Dieses benutzerdefinierte Feld wird verwendet. Möchten Sie es archivieren?",
    "Reconnect": "Wieder verbinden",
    "Send test email": "Test-E-Mail senden",
    "Email address or username": "E-Mail-Adresse oder Benutzername",
    "Other": "Andere",
    "Set default email server for company": "Legen Sie den Standard-E-Mail-Server für das Unternehmen fest",
    "My default email": "Meine Standard-E-Mail",
    "Depends on": "Kommt drauf an",
    "Todo - Blocking": "Alles blockierend",
    "In progress - Blocking": "In Bearbeitung – Blockierung",
    "In progress": "Im Gange",
    "Client code": "Kundencode",
    "Primary user": "Hauptbenutzer",
    "Added date": "Datum hinzugefügt",
    "Updated": "Aktualisiert",
    "Contract count": "Vertragsanzahl",
    "Integration": "Integration",
    "No data available": "Keine Daten verfügbar",
    "No results found": "Keine Ergebnisse gefunden",
    "Loading": "Laden",
    "Sort by": "Sortieren nach",
    "Rows per page": "Zeilen pro Seite",
    "{0}-{1} of {2}": "{0}-{1} von {2}",
    "Ongoing": "Laufend",
    "important": "wichtig",
    "Read more": "Weiterlesen",
    "Add to previous time entry": "Zum vorherigen Zeiteintrag hinzufügen",
    "Add to next time entry": "Zum nächsten Eintrag hinzufügen",
    "Add new task": "Neue Aufgabe hinzufügen",
    "Cut previous time entry": "Vorherigen Zeiteintrag ausschneiden",
    "Cut next time entry": "Nächsten Eintrag ausschneiden",
    "Missing time entry": "Fehlender Zeiteintrag",
    "Overlapping time entries": "Überlappende Zeiteinträge",
    "Member from custom fields": "Mitglied aus benutzerdefinierten Feldern",
    "Delegated to": "Delegiert",
    "Delegated by": "Delegiert von",
    "Visible members": "Sichtbare Mitglieder",
    "Member type": "Mitgliedertype",
    "Groups": "Gruppen",
    "Custom field": "Benutzerdefinierte Feld",
    "Contact search": "Kontaktsuche",
    "Task start": "Aufgabe starten",
    "Task due": "Aufgabe fällig",
    "Task finish": "Aufgabe beenden",
    "Custom date": "Benutzerdefiniertes Datum",
    "Never": "Niemals",
    "Agreed work is still expected": "Es wird weiterhin mit vereinbarten Arbeitzeiten gerechnet",
    "Accepted flextime": "Akzeptierte Gleitzeit",
    "Declined flextime": "Gleitzeit abgelehnt",
    "Cancelled flextime": "Gleitzeit gestrichen",
    "Updated flextime": "Aktualisierte Gleitzeit",
    "Calendar deleted": "Kalender gelöscht",
    "Calendar created": "Kalender erstellt",
    "Calendar approved": "Kalender genehmigt",
    "Calendar declined": "Kalender abgelehnt",
    "Calendar updated": "Kalender aktualisiert",
    "Flextime balance updated": "Gleitzeitsaldo aktualisiert",
    "Flextime": "Gleitzeit",
    "Vacation": "Urlaub",
    "Balance": "Saldo",
    "Comment": "Kommentar",
    "History": "Geschichte",
    "Action": "Aktion",
    "Who": "WHO",
    "Take a vacation or mark an absence": "Machen Sie Urlaub oder markieren Sie eine Abwesenheit",
    "Away": "Weg",
    "Flextime bonus": "Gleitzeitbonus",
    "Approver": "Genehmiger",
    "Vacation available": "Urlaub möglich",
    "Type": "Typ",
    "Reduce agreed working hours": "Vereinbarte Arbeitszeit reduzieren",
    "Reject": "Ablehnen",
    "Approve": "Genehmigen",
    "away_type_Away": "Abwesend",
    "Sick leave": "Krankenstand",
    "Parental leave": "Elternurlaub",
    "Working hours": "Working hours",
    "Mon-Fri, 40h weekly, 8h daily": "Mon-Fri, 40h weekly, 8h daily",
    "Customize": "Customize",
    "Total": "Gesamt",
    "Settings": "Einstellungen",
    "Work on holidays": "An Feiertagen arbeiten",
    "Expand": "Expandieren",
    "Wait until event status": "Warten Sie bis zum Ereignisstatus",
    "Wait until project status": "Warten bis zum Projektstatus",
    "Week(s)": "Wochen)",
    "Day(s)": "Tage)",
    "Rule": "Regel",
    "Depends on event": "Abhängig von der Veranstaltung",
    "Depends on project": "Hängt vom Projekt ab",
    "Due date in": "Fälligkeitsdatum in",
    "Status": "Status",
    "Select event": "Veranstaltung auswählen",
    "Select project": "Projekt auswählen",
    "Find event...": "Veranstaltung finden...",
    "Find project...": "Projekt finden...",
    "Custom recurrence": "Benutzerdefinierte Wiederholung",
    "Every": "Jeden",
    "In case of holiday": "Im Falle eines Urlaubs",
    "Set time": "Zeit einstellen",
    "Start time": "Startzeit",
    "Repeat from": "Wiederholen ab",
    "Previous repeat from: {0}": "Vorherige Wiederholung von: {0}",
    "On date": "Am Datum",
    "Plus days": "Plustage",
    "Due date time": "Uhrzeit des Fälligkeitsdatums",
    "Remove recurrence": "Wiederholung entfernen",
    "Repeat": "Wiederholen",
    "month": "Monat",
    "quarter": "Quartal",
    "year": "Jahr",
    "1st month": "1. Monat",
    "2nd month": "2. Monat",
    "3rd month": "3. Monat",
    "Day {0}": "Tag {0}",
    "Show before": "Vorher anzeigen",
    "Keep the day": "Behalte den Tag",
    "Show after": "Danach anzeigen",
    "From start date": "Ab Startdatum",
    "From beginning of the month": "Ab Anfang des Monats",
    "All days (Mon to Sun)": "Alle Tage (Mo bis So)",
    "Mon to Fri (incl. holidays)": "Mo bis Fr (inkl. Feiertage)",
    "Mon to Fri (excl. holidays)": "Mo bis Fr (außer Feiertage)",
    "1st": "1",
    "2nd": "2",
    "3rd": "3",
    "Does not repeat": "Wiederholt sich nicht",
    "Daily": "Täglich",
    "Weekly on {0}": "Wöchentlich am {0}",
    "Monthly on day {0}": "Monatlich am Tag {0}",
    "Quarterly on {0} month {1} day": "Vierteljährlich am {0} Monat {1} Tag",
    "Yearly on {0} {1}": "Jährlich am {0} {1}",
    "Custom...": "Brauch...",
    "Incorrect time": "Falsche Zeit",
    "Add repeat": "Wiederholung hinzufügen",
    "Email added to queue": "E-Mail zur Warteschlange hinzugefügt",
    "Communication timeline": "Zeitleiste der Kommunikation",
    "Activate Email App in App Store to send automated emails and view your past and future communication in one place.": "Aktivieren Sie die E-Mail-App im App Store, um automatisierte E-Mails zu versenden und Ihre vergangene und zukünftige Kommunikation an einem Ort anzuzeigen.",
    "Go to App Store": "App einrichten",
    "Unknown": "Unbekannt",
    "<b>Email</b> from": "<b>E-Mail</b> von",
    "To": "Zu",
    "Planned": "Geplant",
    "Automated emails scheduled to be sent in the future": "Der Versand automatisierter E-Mails ist für die Zukunft geplant",
    "Send e-mail": "E-Mail senden",
    "Template unlinked": "Vorlage nicht verknüpft",
    "Icon": "Symbol",
    "Link name": "Link name",
    "Link URL": "Link URL",
    "Open in new tab": "Open in new tab",
    "Visible": "Sichtbar",
    "External": "External",
    "Not external": "Not external",
    "Company default": "Unternehmen Standard",
    "Not visible": "Not visible",
    "Use company default": "Use company default",
    "or choose icon": "or choose icon",
    "Find member...": "Mitglied finden...",
    "I'll take it": "Ich nehme es",
    "Remove me": "Entferne mich",
    "Remove from task": "Aus Aufgabe entfernen",
    "Learn more": "Erfahren Sie mehr",
    "Company settings edit is disabled by owner": "Die Bearbeitung der Unternehmenseinstellungen wurde vom Besitzer deaktiviert",
    "<b>Exported</b> {0} to {1}": "<b>Exportiert</b> {0} nach {1}",
    "<b>Sent to client</b> {0} from {1}": "<b>Sent to client</b> {0} from {1}",
    "<b>Paid {0}</b> {1}": "<b>Bezahlt {0}</b> {1}",
    "<b>Annulled</b> {0}": "<b>Aufgehoben</b> {0}",
    "Do you wish to mark the task done for everyone?": "Möchten Sie die Aufgabe für alle als erledigt markieren?",
    "No, remove me": "Nein, entferne mich",
    "Task won’t be marked done, but user is removed from the assignees and added to the followers of the task": "Die Aufgabe wird nicht als erledigt markiert, aber der Benutzer wird aus den Verantwortlichen entfernt und zu den Followern der Aufgabe hinzugefügt",
    "Invalid email": "Ungültige E-Mail",
    "Accounting": "Buchhaltung",
    "General": "Allgemein",
    "Advertising / Marketing/ PR": "Werbung / Marketing / PR",
    "Architecture": "Die Architektur",
    "Construction": "Konstruktion",
    "Consulting - IT, software": "Beratung - IT, Software",
    "Consulting - Management": "Beratung - Management",
    "Finance": "Finanzen",
    "Legal": "Legal",
    "Medicine / Pharmacy ": "Medizin / Pharmazie",
    "Non-profit": "Gemeinnützig",
    "Web design": "Web-Design",
    "Web development": "Web Entwicklung",
    "Max 140 characters": "Maximal 140 Zeichen",
    "Please complete the checklist": "Bitte füllen Sie die Checkliste aus",
    "It is required to mark all checklist items as done": "Es ist erforderlich, alle Punkte der Checkliste als erledigt zu markieren",
    "Please enter time spent": "Bitte geben Sie die aufgewendete Zeit ein",
    "Inserting time is essential for this client": "Für diesen Kunden ist es wichtig, Zeit einzubringen",
    "Only me": "Nur ich",
    "Private": "Privatgelände",
    "Edit note": "Notiz bearbeiten",
    "Add additional information about the client, such as special agreements, passwords, etc.": "Fügen Sie zusätzliche Informationen zum Kunden hinzu, wie z. B. Sondervereinbarungen, Passwörter usw.",
    "Edit": "Bearbeiten",
    "Workdays": "Arbeitstage",
    "Workhours": "Arbeitsstunden",
    "Weeks": "Wochen",
    "Clear filters": "Filter löschen",
    "Save filters": "Filter speichern",
    "Expected": "Erwartet",
    "Estimation": "Einschätzung",
    "Do you also want to postpone the due date?": "Möchten Sie auch den Fälligkeitstermin verschieben?",
    "{0} week": "{0} Woche",
    "{0} weeks": "{0} Wochen",
    "Vacations": "Urlaube",
    "Holidays": "Feiertage",
    "Tax dates": "Steuertermine",
    "Accounting news": "Buchhaltungsnachrichten",
    "Company events": "Firmenveranstaltungen",
    "Member birthdays": "Geburtstage der Mitglieder",
    "Contact birthdays": "Kontakt Geburtstage",
    "Group items": "Artikel gruppieren",
    "Don't group": "Nicht gruppieren",
    "{0} away": "{0} weg",
    "Member birthday | Member birthdays": "Mitgliedergeburtstag | Mitgliedergeburtstage",
    "Contact birthday | Contact birthdays": "Kontakt Geburtstag | Kontakt Geburtstage",
    "Contact birthday": "Geburtstag kontaktieren",
    "Member birthday": "Mitglied Geburtstag",
    "Are you sure you wish to delete this link?": "Sind Sie sicher, dass Sie diesen Link löschen möchten?",
    "Reference name": "Referenzname",
    "Reference link": "Referenzlink",
    "Free trial": "Kostenlose Testphase",
    "Solo": "Allein",
    "Team": "Team",
    "Enterprise": "Unternehmen",
    "Mini Uku": "Mini-Uku",
    "Chrome browser plugin for Uku to manage your task, clients and track time.": "Chrome-Browser-Plugin für Uku zum Verwalten Ihrer Aufgaben, Kunden und Zeiterfassung.",
    "Setup task/job plans to automate your workflow, add topics, custom fields and modify your preferences.": "Richten Sie Aufgaben-/Jobpläne ein, um Ihren Arbeitsablauf zu automatisieren, Themen und benutzerdefinierte Felder hinzuzufügen und Ihre Einstellungen zu ändern.",
    "Setup client groups, custom fields and modify your preferences.": "Richten Sie Kundengruppen und benutzerdefinierte Felder ein und ändern Sie Ihre Einstellungen.",
    "test": "prüfen",
    "Anti Money Laundering": "Geldwäschebekämpfung",
    "Setup your customer AML and get instant reminders when auditing is due.": "Richten Sie Ihr Kunden-AML ein und erhalten Sie sofortige Erinnerungen, wenn eine Prüfung fällig ist.",
    "flextime_description": "Verwalten Sie die Work-Life-Balance mit Leichtigkeit.",
    "Smart Accounts": "Intelligente Konten",
    "Automatically imports work statistics from your accounting software.": "Importiert automatisch Arbeitsstatistiken aus Ihrer Buchhaltungssoftware.",
    "Merit Aktiva": "Verdienst aktiv",
    "360 Księgowość": "360 Buchhaltung",
    "Speed up your client billing process with pricelists and smart contracts.": "Beschleunigen Sie Ihren Kundenabrechnungsprozess mit Preislisten und Smart Contracts.",
    "Visual report will tell you exactly how profitable or unprofitable your client is.": "Der visuelle Bericht zeigt Ihnen genau, wie profitabel oder unrentabel Ihr Kunde ist.",
    "Emailing description": "Beschreibung per E-Mail senden",
    "e-conomic": "e-conomic",
    "Sync client data from Uku to e-conomic and vice versa. View sales ledger information for each client.": "Synchronisieren Sie Kundendaten von Uku mit e-conomic und umgekehrt. Zeigen Sie Verkaufsbuchinformationen für jeden Kunden an.",
    "Xero": "Xero",
    "xero_description": "Importieren Sie Kunden von Xero nach Uku und automatisieren Sie Ihre Abrechnung.",
    "QuickBooks": "QuickBooks",
    "quickbooks_description": "Importieren Sie Kunden von Quickbooks Online nach Uku und automatisieren Sie Ihre Abrechnung.",
    "Tripletex": "Tripletex",
    "tripletex_description": "Importieren Sie Kunden von Tripletex nach Uku und automatisieren Sie Ihre Abrechnung.",
    "Scoro": "Scoro",
    "Export sales invoices.": "Verkaufsrechnungen exportieren.",
    "Fortnox": "Fortnox",
    "fortnox_description": "Importieren Sie Kunden von Fortnox nach Uku und automatisieren Sie Ihre Abrechnung.",
    "Magic button": "Magischer Knopf",
    "With one click - a quick and easy way to create important tasks. For example, a phone call from a client.": "Mit einem Klick – schnell und einfach wichtige Aufgaben erstellen. Zum Beispiel ein Anruf eines Kunden.",
    "With suppliers, you make your projects and partners management more efficient.": "Mit Lieferanten gestalten Sie Ihr Projekt- und Partnermanagement effizienter.",
    "Powerful and flexible project management serves diverse use cases and workflows.": "Leistungsstarkes und flexibles Projektmanagement bedient vielfältige Anwendungsfälle und Arbeitsabläufe.",
    "client_portal_app_description": "Das Kundenportal vereinfacht die Zusammenarbeit mit Kunden. Empfangen Sie Dokumente sicher, erteilen Sie Aufgaben und teilen Sie Informationen.",
    "Chat": "Plaudern",
    "chat_app_description": "Verbessern Sie die Zusammenarbeit im Team, die Kundenkommunikation und die Gesamteffizienz mit dem Chat.",
    "Companies House": "Companies House",
    "companies_house_app_description": "Importieren Sie Unternehmensdaten britischer Unternehmen aus dem britischen Handelsregister.",
    "documents_app_description": "documents_app_description",
    "Connect and discover tools to help you manage your business.": "Verbinden Sie sich und entdecken Sie Tools, die Sie bei der Verwaltung Ihres Unternehmens unterstützen.",
    "Subscribe now": "Abonniere jetzt",
    "Compare plans": "Tarife vergleichen",
    "Add company": "Firma hinzufügen",
    "BETA": "BETA",
    "Setup": "Aufstellen",
    "Power up": "Einschalten",
    "Integrations": "Integrationen",
    "Hi! Do you want to work with a team and use extra features? No problem, first add your company!": "Hallo! Möchten Sie im Team arbeiten und zusätzliche Funktionen nutzen? Kein Problem, fügen Sie zuerst Ihr Unternehmen hinzu!",
    "Read more about Uku plans": "Lesen Sie mehr über Uku-Pläne",
    "Contact role": "Kontaktrolle",
    "Contact roles": "Kontaktrollen",
    "Client groups": "Kundengruppen",
    "Client fields": "Kundenfelder",
    "Contact fields": "Kontaktfelder",
    "View archive": "Archiv ansehen",
    "Restore from archive": "Aus Archiv wiederherstellen",
    "Empty list": "Leere Liste",
    "Task fields": "Aufgabenfelder",
    "task topics": "Aufgabenthemen",
    "Keep the task opened when starting the timer": "Lassen Sie die Aufgabe geöffnet, wenn Sie den Timer starten",
    "task templates": "Aufgabenvorlagen",
    "Author": "Autor",
    "Duplicate": "Duplikat",
    "Uku task templates": "Uku Aufgabenvorlagen",
    "Are you sure that you want to delete this task template?": "Sind Sie sicher, dass Sie diese Aufgabenvorlage löschen möchten?",
    "Templates": "Vorlagen",
    "Overview": "Überblick",
    "chat_app_overview_text": "<p class='title'>Uku Chat is a user-friendly and secure messaging tool tailored to streamline communication, collaboration, and task management.</p> <div class='body-2'><p>Key functionalities include:</p><ul><li>Real-time messaging: Send instant messages to team members and clients. It has options for direct messages, group chats, and dedicated channels for specific topics.</li><li>Task management: Create a new task from a conversation.</li><li>ChatGPT integration: Summarize the conversation, change the tone of voice, and request recommendations for response.</li><li>Customizable notifications: Tailor notifications to your preferences.</li></ul></div>",
    "Color": "Farbe",
    "Are you sure to delete this field? You may lose the data.": "Möchten Sie dieses Feld wirklich löschen? Es kann sein, dass die Daten verloren gehen.",
    "Add field": "Feld hinzufügen",
    "Add section": "Abschnitt hinzufügen",
    "multiline": "mehrzeilig",
    "Import data": "Daten importieren",
    "Automate data collection with Smart Accounts": "Automatisieren Sie die Datenerfassung mit Smart Accounts",
    "<ul><li>Import purchase and sales entries, total entries and entry lines count;</li><li>Automate data collection with Smart Accounts;</li><li>Faster & more accurate billing through automated data exchange. Uku gathers information for preparing customers' invoices in one place and makes invoicing efficient.</li></ul>": "<ul><li>Einkaufs- und Verkaufseinträge, Gesamteinträge und Anzahl der Eintragszeilen importieren;</li><li>Datenerfassung mit Smart Accounts automatisieren;</li><li>Schnellere und genauere Abrechnung durch automatisierten Datenaustausch. Uku sammelt Informationen zur Erstellung von Kundenrechnungen an einem Ort und sorgt für eine effiziente Rechnungsstellung.</li></ul>",
    "xero_app_overview_text": "<p class='title'>Automatisieren Sie Ihren Abrechnungsprozess, indem Sie Xero mit Uku verbinden.</p> <div class='body-2'><p>Vorteile der Xero-Integration:</p><ul><li >Importieren Sie alle Ihre Kunden mit nur wenigen Klicks aus Xero nach Uku</li><li>Importieren Sie Produktcodes und Klassifikatoren nach Uku</li><li>Erstellen Sie Rechnungen automatisch in Uku und senden Sie sie an Xero</li> </ul></div>",
    "Import clients from {0}": "Kunden aus {0} importieren",
    "Before importing clients, you need to authorize with Xero and select the Company.": "Bevor Sie Kunden importieren, müssen Sie sich bei Xero autorisieren und das Unternehmen auswählen.",
    "Authorize Xero to start import": "Autorisieren Sie Xero, den Import zu starten",
    "Failed to import clients": "Clients konnten nicht importiert werden",
    "Failed to connect to WS": "Verbindung zum WS fehlgeschlagen",
    "Import": "Importieren",
    "emailing_app_overview_text": "<p class='title'><b>Fast and convenient client communication</b></p><div class='body-2'><p>Send one-time emails or set up automated emails. You can do both from the task view.</p><p><b>Automated emails</b></p><p>Add an automatic email to recurring tasks. For example, set up an automatic email \"Missing documents\" to the task \"Documents entry\" which will be sent out 2 days before the task starts. This way you have all necessary documents when starting working on the task.</p><p><b>Email templates</b></p><p>Save emails you often send conveniently as a template. This saves you the hassle of constantly composing messages with the same content.</p></div>",
    "Email signatures": "Email signatures",
    "Everyone": "Alle",
    "Access": "Zugang",
    "Creator": "Schöpfer",
    "Are you sure you want to delete this signature? Some emails will be affected": "Are you sure you want to delete this signature? Some emails will be affected",
    "Email addresses": "E-mailadressen",
    "Signatures": "Signatures",
    "Send emails": "Send emails",
    "Uku securely integrates with your email to help you manage and automate communication": "Uku lässt sich sicher in Ihre E-Mail integrieren, um Sie bei der Verwaltung und Automatisierung der Kommunikation zu unterstützen",
    "Use {0} address": "Adresse {0} verwenden",
    "connect your email address": "Verbinden Sie Ihre E-Mail-Adresse",
    "Connect with Microsoft Exchange or other email server(SMTP)": "Verbinden Sie sich mit Microsoft Exchange oder einem anderen E-Mail-Server (SMTP).",
    "Email integration reconnected": "E-Mail-Integration wiederhergestellt",
    "Are you sure you want to delete this email integration?": "Sind Sie sicher, dass Sie diese E-Mail-Integration löschen möchten?",
    "Email templates": "E-Mail-Vorlagen",
    "Add email template": "E-Mail-Vorlage hinzufügen",
    "Are you sure you want to save this template? Some tasks will be affected": "Möchten Sie diese Vorlage wirklich speichern? Einige Aufgaben werden davon betroffen sein",
    "Clients can leave task messages by replying to client portal email": "Clients can leave task messages by replying to client portal email",
    "Send a copy of client's response to member's inbox": "Send a copy of client's response to member's inbox",
    "Email recipients can leave task comments by replying to a task email": "Email recipients can leave task comments by replying to a task email",
    "economic_app_overview_text": "<p class='title'>Automate your billing process by connecting e-conomic to Uku</p><div class='body-2'><p>e-conomic integration enables you to:<ul><li>import all your clients from e-conomic to Uku with just a couple of clicks</li><li>import products and classificators from e-conomic to Uku</li><li>create invoices automatically in Uku and send them to e-conomic</li></ul></p></div>",
    "Default layout": "Standardlayout",
    "Change agreement ID": "Vertrags-ID ändern",
    "Failed to connect to server": "Verbindung zum Server fehlgeschlagen",
    "Uku will import all clients, clients info and classificatiors. In the final step you can select which clients you want to add or update.": "Uku importiert alle Kunden, Kundeninformationen und Klassifizierungen. Im letzten Schritt können Sie auswählen, welche Clients Sie hinzufügen oder aktualisieren möchten.",
    "Connect e-conomic": "Connect e-conomic",
    "Before importing clients, you need to connect Uku and economic software. To do this, create economic agreement and enter the agreement ID here.": "Bevor Sie Kunden importieren, müssen Sie Uku und Wirtschaftssoftware verbinden. Erstellen Sie dazu eine Wirtschaftsvereinbarung und geben Sie hier die Vertrags-ID ein.",
    "Step {0}": "Schritt {0}",
    "Get agreement ID": "Vereinbarungs-ID abrufen",
    "Insert agreement ID": "Geben Sie die Vertrags-ID ein",
    "Connect": "Verbinden",
    "quickbooks_app_overview_text": "<p class='title'>Automatisieren Sie Ihren Abrechnungsprozess, indem Sie QuickBooks Online mit Uku verbinden.</p> <div class='body-2'><p>Vorteile der QuickBooks-Integration:</p><ul><li>mportieren Sie alle Ihre Kunden mit nur wenigen Klicks aus QuickBooks nach Uku.</li><li>Importieren Sie Produkten und Klassifikatoren nach Uku.</li><li>Erstellen Sie Rechnungen automatisch in Uku und senden Sie sie an QuickBooks.</li></ul></div>",
    "Uku will import all clients, clients info and classificatiors from QuickBooks. In the final step you can select which clients you want to add or update.": "Uku importiert alle Kunden, Kundeninformationen und Klassifizierer aus QuickBooks. Im letzten Schritt kannst du auswählen, welche Kunden du hinzufügen oder aktualisieren möchtest.",
    "Before importing clients, you need to connect with QuickBooks.": "Bevor du Kunden importieren kannst, musst du eine Verbindung zu QuickBooks herstellen.",
    "Connected to QuickBooks": "Verbunden mit QuickBooks",
    "fortnox_app_overview_text": "<p class='title'>Automatisieren Sie Ihren Abrechnungsprozess, indem Sie Fortnox mit Uku verbinden.</p> <div class='body-2'><p>Vorteile der Fortnox-Integration:</p><ul><li>mportieren Sie alle Ihre Kunden mit nur wenigen Klicks aus Fortnox nach Uku.</li><li>Importieren Sie Produkten und Klassifikatoren nach Uku.</li><li>Erstellen Sie Rechnungen automatisch in Uku und senden Sie sie an Fortnox.</li></ul></div>",
    "Uku will import all clients, clients info and classificators from Fortnox. In the final step you can select which clients you want to add or update.": "Uku importiert alle Kunden, Kundeninformationen und Klassifikatoren aus Fortnox. Im letzten Schritt kannst du auswählen, welche Kunden du hinzufügen oder aktualisieren möchtest.",
    "Before importing clients, you need to connect with Fortnox.": "Bevor du Kunden importieren kannst, musst du dich mit Fortnox verbinden.",
    "Connect to Fortnox": "Mit Fortnox verbinden",
    "Connected to Fortnox": "Verbunden mit Fortnox",
    "Delete template": "Vorlage löschen",
    "Public": "Öffentlich",
    "Workflow templates": "Workflow-Vorlagen",
    "No workflow templates yet": "Noch keine Workflow-Vorlagen",
    "Modified": "Geändert",
    "Uku workflow templates": "Uku Workflow-Vorlagen",
    "Are you sure you wish to delete this workflow?": "Sind Sie sicher, dass Sie diesen Workflow löschen möchten?",
    "Project fields": "Projektfelder",
    "Progress step": "Fortschrittsschritt",
    "Rename project": "Projekt umbenennen",
    "Project statuses": "Projektstatus",
    "You can use the statuses to restrict the workflow.": "Über die Status können Sie den Workflow einschränken.",
    "Project phases": "Projektphasen",
    "Make your progress beautiful.": "Machen Sie Ihren Fortschritt schön.",
    "Permissions": "Berechtigungen",
    "Users can manage workflow templates": "Benutzer können Workflow-Vorlagen verwalten",
    "project_app_overview_text": "Verwalten Sie Ihre Projekte von Start bis zum Abschluss.",
    "project_app_overview_description": "<div class=‘body-2’><p>Plan and execute tasks, track your projects, and never have a task fall through the cracks.</p><p>Key features:</p><ul><li><b>Creating projects: </b>Create projects using ready-made, customisable project templates. Keep non-accounting projects like client or employee onboarding separate from daily tasks. You can also start projects from scratch to tailor projects precisely to your needs.</li><li><b>Task management: </b>Break projects into tasks, assign responsibilities, and set due dates and dependencies. Separate extra services from daily accounting tasks.</li><li><b>Progress tracking: </b>The interactive project overview helps visualise progress, allowing for effective project schedule management. For instance, project tasks, like onboarding and off-boarding templates, look different from your regular tasks.</li><li><b>Customisation: </b>Tailor projects to your organisation’s needs with customisable fields and workflow templates. Have tasks depend on the project’s start or due date rather than a specific date of the month, providing flexibility and adaptability to project management.</li></ul></div>",
    "Configure summary task": "Sammelaufgabe konfigurieren",
    "Uku will generate task with following title and topic on the last day of the month.": "Uku generiert am letzten Tag des Monats eine Aufgabe mit folgendem Titel und Thema.",
    "Task title": "Aufgabentitel",
    "Recurrence": "Wiederauftreten",
    "Count changes from previous periods": "Zählungsänderungen gegenüber den Vorperioden",
    "If enabled, changes made to previous periods will be added to current month. If disabled, changes made to previous periods will not be accounted for.": "Wenn diese Option aktiviert ist, werden Änderungen, die in früheren Zeiträumen vorgenommen wurden, zum aktuellen Monat hinzugefügt. Wenn sie deaktiviert ist, werden Änderungen in früheren Zeiträumen nicht berücksichtigt.",
    "Configure data fields": "Datenfelder konfigurieren",
    "Select corresponding Uku field for each imported field. Same fields will be summarized. By leaving some field blank it will be ignored.": "Wählen Sie für jedes importierte Feld das entsprechende Uku-Feld aus. Gleiche Felder werden zusammengefasst. Wenn Sie ein Feld leer lassen, wird es ignoriert.",
    "New custom field": "Neues benutzerdefiniertes Feld",
    "Show more": "Zeig mehr",
    "Every month": "Jeden Monat",
    "Last day of the month": "Ultimo",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "10": "10",
    "11": "11",
    "12": "12",
    "13": "13",
    "14": "14",
    "15": "15",
    "16": "16",
    "17": "17",
    "18": "18",
    "19": "19",
    "20": "20",
    "21": "21",
    "22": "22",
    "23": "23",
    "24": "24",
    "25": "25",
    "26": "26",
    "27": "27",
    "28": "28",
    "Day {0} of next month": "Tag {0} des nächsten Monats",
    "Settings saved": "Einstellungen gespeichert",
    "Uku will let you know when it is ready.": "Uku wird dir Bescheid geben, wenn es fertig ist.",
    "Reload data": "Daten neu laden",
    "months": "Monate",
    "This will overwrite existing summary tasks new values.": "Dadurch werden bestehende Sammelaufgaben mit neuen Werten überschrieben.",
    "Overwrite": "Überschreiben",
    "Automate your anti money laundering process": "Automatisieren Sie Ihren Prozess zur Geldwäschebekämpfung",
    "You are about to activate anti money laundering process. During that new additional fields will be added to your clients data and also system will start reminding you about updating them.<br><br>Additional fields are:<ul><li>Risk profile</il><li>Profile valid until</il><li>AML Staus</il><li>Document NO</il><li>Document valid until</li></ul>": "Sie sind dabei, den Prozess zur Bekämpfung der Geldwäsche zu aktivieren. Dabei werden neue zusätzliche Felder zu Ihren Kundendaten hinzugefügt und das System beginnt, Sie an die Aktualisierung zu erinnern.<br><br>Zusätzliche Felder sind:<ul><li>Risikoprofil</il><li>Profil gültig bis</il><li>AML Staus</il><li>Dokument Nr.</il><li>Dokument gültig bis</li></ul>",
    "You are about to activate anti money laundering process. During that new additional fields will be added to your clients data and also system will start reminding you about updating them.<br><br>Additional fields are:<ul><li>Risk profile</il><li>Next AML check</il><li>Pass/Fail</il><li>ID type</il><li>ID Number</il><li>Date of expiry</il><li>Additional checks</li></ul>": "Sie sind dabei, den Prozess zur Bekämpfung der Geldwäsche zu aktivieren. Währenddessen werden neue zusätzliche Felder zu Ihren Kundendaten hinzugefügt und das System beginnt, Sie an deren Aktualisierung zu erinnern.<br><br>Zusätzliche Felder sind:<ul><li>Risikoprofil</il><li>Nächste AML Prüfung</il><li>Bestanden/Nicht bestanden</il><li>ID-Typ</il><li>ID-Nummer</il><li>Ablaufdatum</il><li>Zusätzliche Prüfungen</ li></ul>",
    "Do not change client custom fields created by Uku": "Ändern Sie keine von Uku erstellten benutzerdefinierten Kundenfelder",
    "day(s) before": "Tage zuvor",
    "Task name": "Aufgabennname",
    "Assigned": "Zugewiesen",
    "Note": "Notiz",
    "Manual run": "Manueller Lauf",
    "Create a task when the document expires": "Erstellen Sie eine Aufgabe, wenn das Dokument abläuft",
    "Create a task when the risk profile must be updated": "Erstellen Sie eine Aufgabe, wenn das Risikoprofil aktualisiert werden muss",
    "Flextime period": "Gleitzeitzeitraum",
    "Confirmation period": "Confirmation period",
    "Weekly": "Wöchentlich",
    "Add agreement": "Vereinbarung hinzufügen",
    "flextime_app_overview_text": "<p class='title'>Erhalten Sie einen Überblick über die Arbeitszeiten, Überstunden und den Urlaubssaldo Ihres Teams.</p> <div class='body-2'><p></p><p>Vorteile der Flextime:</p><ul><li>Praktischer Überblick über Arbeit und Überstunden</li><li>Zugängliche Urlaubsverwaltung und Saldenübersicht</li><li>Einfacher Datenexport für Ihren Buchhalter</li></ul></div>",
    "supplier_app_overview_text": "Manage your partners and vendors.",
    "supplier_app_overview_description": "<div class='body-2'><p>Your partners and third party organisations can be managed here in a separate register. You will no longer have to keep a list of contacts in an Excel sheet.</p></div>",
    "Supplier type": "Lieferantentyp",
    "Parent type": "Übergeordneter Typ",
    "Edit supplier type": "Lieferantentyp bearbeiten",
    "New supplier type": "Neuer Lieferantentyp",
    "Are you sure you wish to delete this supplier type?": "Sind Sie sicher, dass Sie diesen Lieferantentyp löschen möchten?",
    "Types": "Typen",
    "Supplier types": "Lieferantentypen",
    "No supplier types yet": "Noch keine Lieferantentypen",
    "tripletex_app_overview_text": "<p class='title'>Automatisieren Sie Ihren Abrechnungsprozess, indem Sie Tripletex mit Uku verbinden.</p> <div class='body-2'><p>Vorteile der Tripletex-Integration:</p><ul><li>mportieren Sie alle Ihre Kunden mit nur wenigen Klicks aus Tripletex nach Uku.</li><li>Importieren Sie Produkten und Klassifikatoren nach Uku.</li><li>Erstellen Sie Rechnungen automatisch in Uku und senden Sie sie an Tripletex.</li></ul></div>",
    "Uku will import all clients, clients info and classificators from Tripletex. In the final step you can select which clients you want to add or update.": "Uku importiert alle Kunden, Kundeninformationen und Klassifikatoren aus Tripletex. Im letzten Schritt kannst du auswählen, welche Kunden du hinzufügen oder aktualisieren möchtest.",
    "Connect Tripletex": "Tripletex verbinden",
    "Before importing clients, you need to connect Uku and Tripletex software. To do this, create employee token and enter it here.": "Bevor du Kunden importieren kannst, musst du Uku mit der Tripletex-Software verbinden. Dazu erstellst du ein Mitarbeiter-Token und gibst es hier ein.",
    "Get employee token": "Mitarbeiter-Token erhalten",
    "Insert employee token": "Mitarbeiter-Token einfügen",
    "Install": "Installieren",
    "Open Chrome browser to install": "Öffnen Sie den Chrome-Browser zur Installation",
    "Works with your online accounting software.": "Funktioniert mit Ihrer Online-Buchhaltungssoftware.",
    "New tasks can strike like lightning and that’s why Mini Uku is your best friend. No matter whether you’re making bank transfers or working in your accounting software; with Mini Uku you can add new tasks, track time and keep on top of all your notifications from any website.<br><br>Just one click on the owl icon provides an overview of your entire working day and helps you plan your schedule more efficiently.": "Neue Aufgaben können wie ein Blitz einschlagen und deshalb ist Mini Uku dein bester Freund. Egal, ob Sie Banküberweisungen tätigen oder in Ihrer Buchhaltungssoftware arbeiten; Mit Mini Uku können Sie neue Aufgaben hinzufügen, die Zeit verfolgen und alle Ihre Benachrichtigungen von jeder Website aus im Auge behalten.<br><br>Mit nur einem Klick auf das Eulensymbol erhalten Sie einen Überblick über Ihren gesamten Arbeitstag und helfen Ihnen bei der Planung Ihres Zeitplans effizienter.",
    "merit_aktiva_app_overview_text_pl": "merit_aktiva_app_overview_text_pl",
    "merit_aktiva_app_overview_text": "<p class='title'>Import clients and the volume of work to get one report with work done data for all your clients.</p><div class='body-2'><p>Make your data collection fast and accurate with Merit Aktiva and Uku integration. Uku automatically imports sales and purchase invoices, documents, entries, etc. for each client and performs volume of work and time-entries in one interactive report. No more switching between clients in your accounting software to get information about documents processed to create invoices or monitor client performance. Compared to Merit, Uku imports the actual amount of entries for last month, taking into account all changes that were inserted into previous periods. Meaning that you don't have to remember or write down any changes you have made - Uku has all that information and so will you. Automated data collection saves you time and eliminates human errors.</p><p>Uku and Merit Aktiva integration helps you to:</p><p><ul><li>Quickly and accurately gather data - volume of work is imported to Uku from Merit automatically</li><li>Analyse workload and time by having a full overview of work done and time spent on clients</li><li>Automate the creation of monthly summaries </li><li>Get an overview of the actual workload each month</li></ul></p><p>With Uku - Merit integration you can import the amount of:</p><p><ul><li>Documents</li><li>Entries</li><li>Sales invoices</li><li>Purchase invoices</li><li>Bank entries</li><li>Cash entries</li><li>VAT entries</li><li>Stock entries</li><li>Etc.</li></ul></p></div>",
    "Import clients": "Kunden importieren",
    "documents_app_overview_text": "documents_app_overview_text",
    "Connect your existing document management system": "Connect your existing document management system",
    "Main folder": "Main folder",
    "Under this folder, Uku automatically creates folders for each client.": "Under this folder, Uku automatically creates folders for each client.",
    "You can customize each client folder separately under client settings.": "You can customize each client folder separately under client settings.",
    "Automatically create Public folder for client files and Private folder for member files": "Automatically create Public folder for client files and Private folder for member files",
    "Automatically create  Year / Month subfolder under each client for files sorting": "Automatically create  Year / Month subfolder under each client for files sorting",
    "Automatically create  Notes and Templates subfolders under each client for files sorting": "Automatically create  Notes and Templates subfolders under each client for files sorting",
    "Add task files added by Members": "Add task files added by Members",
    "Add task files added by Clients (from emails and client portal)": "Add task files added by Clients (from emails and client portal)",
    "Backup files to Uku file storage": "Backup files to Uku file storage",
    "Perfect example": "Perfect example",
    "You are about to disconnect this service.": "You are about to disconnect this service.",
    "Google Drive": "Google Drive",
    "OneDrive": "OneDrive",
    "Select folder": "Select folder",
    "Manage": "Manage",
    "Refresh": "Aktualisierung",
    "Be aware of the issues before they become problems": "Seien Sie sich der Probleme bewusst, bevor sie zu Problemen werden",
    "<ul><li>Real time comparison of client contract and actual work done;</li><li>Be aware of the issues before they become problems;</li><li>Even with fixed prices you need to have internal measurements. Monitor the validity of the client’s agreement by comparing it with the actual amount of work done.</li></ul>": "<ul><li>Vergleich des Kundenvertrags mit der tatsächlich geleisteten Arbeit in Echtzeit.</li><li>Seien Sie sich der Probleme bewusst, bevor sie zu Problemen werden.</li><li>Selbst bei Festpreisen müssen Sie intern sein Messungen. Überwachen Sie die Gültigkeit der Vereinbarung des Kunden, indem Sie sie mit dem tatsächlich geleisteten Arbeitsaufwand vergleichen.</li></ul>",
    "client_portal_app_overview_text": "<div class='body-2'><p>Uku's Client Portal improves your service by simplifying communication between accountants and clients. With Uku's Client Portal, you can speed up communication, reduce email dependency, and offer a secure document-sharing and communication platform.</p><img style='margin-bottom: 12px; width: 100%' src='/static/img/client-portal-app-description-img.png'><p>Client Portals features include:</p><ul><li><b>Magic Links:</b> Client's hassle-free login without usernames and passwords.</li><li><b>Document Digitisation:</b> Submit items to your accounting software with one click.</li><li><b>Client Communication:</b> Assign tasks to clients and send messages fast.</li><li><b>Automatic Reminders:</b> Reduce the amount of manual follow-ups, check statuses: seen, done.</li><li><b>Multilingual Interface:</b> Supports multiple languages for a personalised experience.</li><li><b>Customisable Branding:</b> Add logos, icons, colours and a welcome video to make your clients feel at home.</li></ul><p></p><p>Some Client Portal use cases:</p><p><b>1. Get Client Information:</b></p><ul><li>Add recurring tasks with document requirements.</li><li>The client gets an email and reminder with magic link to the Client Portal.</li><li>Clients upload documents and answer queries in the Client Portal.</li></ul><p></p><p><b>2. Make Finance Reviews:</b></p><ul><li>Add monthly recurring tasks with meeting links.</li><li>The client gets an email and reminder with magic link to the Client Portal.</li><li>Send the client a meeting memo with a recorded video.</li></ul><p></p><p><b>3. Onboard Your Client:</b></p><ul><li>Add an onboarding task from the template.</li><li>The client gets an email and reminder with magic link to the Client Portal.</li><li>The client fills out the checklist (accesses, reports).</li></ul><p></p><p>These use cases demonstrate Uku's Client Portal's task management and communication efficiency.</p><p><a href='https://getuku.com/client-portal' target='_blank'>Read more &rsaquo;</a></p></div>",
    "Branding": "Branding",
    "Subdomain": "Subdomain",
    "Default language": "Standardsprache",
    "Client portal URL in other languages": "URL des Kundenportals in anderen Sprachen",
    "Copy URL": "URL kopieren",
    "Trademark": "Warenzeichen",
    "Trademark text color": "Textfarbe der Marke",
    "Choose color": "Farbe wählen",
    "Brand background color": "Hintergrundfarbe der Marke",
    "Logo": "Logo",
    "Delete logo": "Logo löschen",
    "Upload logo file": "Logo hochladen",
    "Max. dimensions 180 x 60 px": "Maximale Abmessungen 180 x 60 Pixel",
    "Favicon": "Favicon",
    "Delete icon": "Symbol „Löschen“.",
    "Upload icon file": "Symbol hochladen",
    "Recommended size 260 x 260 px": "Empfohlene Größe 260 x 260 Pixel",
    "Company description": "Firmen Beschreibung",
    "Displayed on the login page.": "Wird auf der Anmeldeseite angezeigt.",
    "Describe here what services you offer and how you help your clients.": "Beschreiben Sie hier, welche Dienstleistungen Sie anbieten und wie Sie Ihren Kunden helfen.",
    "Welcome video": "Willkommensvideo",
    "Displayed on the login page when your client contact enters for the first time": "Wird auf der Anmeldeseite angezeigt, wenn Ihr Kundenkontakt zum ersten Mal eintrifft",
    "Use Uku video": "Uku-Video verwenden",
    "View": "Sicht",
    "Use other video": "Anderes Video verwenden",
    "Youtube or Vimeo video URL": "YouTube- oder Vimeo-Video-URL",
    "Show file upload box for client tasks": "Datei-Upload-Box für Kundenaufgaben anzeigen",
    "Invalid data": "Ungültige Daten",
    "Client portal preview": "Vorschau des Kundenportals",
    "Client portal URL for {0} copied to clipboard": "Kundenportal-URL für {0} in die Zwischenablage kopiert",
    "Personalize your client portal's menu": "Personalize your client portal's menu",
    "Menu links saved": "Menu links saved",
    "Add custom links to essential items such as: Documents, Financial reports, Onboarding forms, Feedback surveys, Service agreements, Pricing, Instructions, Invoices. This section allows you to build the menu structure, set the order of items, and define default links. You can also customize names and links for each client individually. Only menus with defined links are displayed in client portal. <a href='/api/help_link/cp_menu_links' target='_blank'>Read more ›</a>": "Add custom links to essential items such as: Documents, Financial reports, Onboarding forms, Feedback surveys, Service agreements, Pricing, Instructions, Invoices. This section allows you to build the menu structure, set the order of items, and define default links. You can also customize names and links for each client individually. Only menus with defined links are displayed in client portal. <a href='/api/help_link/cp_menu_links' target='_blank'>Read more ›</a>",
    "Menu links": "Menu links",
    "Add recurring task": "Wiederkehrende Aufgabe hinzufügen",
    "Reminder tasks updated": "Erinnerung Aufgaben aktualisiert",
    "Create recurring tasks for Companies House clients.": "Erstellen Sie wiederkehrende Aufgaben für Companies House Unternehmen.",
    "companies_house_app_overview_text": "Britisches Unternehmensregister",
    "buttons": "Tasten",
    "Show to me": "Zeig es mir",
    "magic_button_app_overview_text": "<p class='title'>With one click, add a new task and start the timer.</p> <div class='body-2'><p>Magic buttons allow you to insert urgent work (phone call, email) conveniently.</p><p>Insert all tasks immediately to Uku</p><p>Magic buttons allow you to add urgent tasks (phone call, email) to Uku conveniently. That ensures tasks are inserted into Uku properly.</p><p>Magic buttons:</p><ul><li>Insert a new task and start the timer with one click (move to + button in the header).</li><li>Customize magic buttons according to your needs.</li><li>Modify the client or other information afterward.</li><li>Continue with the previous task that you can quickly access from the magic buttons list.</li></ul></div>",
    "Buttons": "Tasten",
    "Member rights": "Rechte der Mitglieder",
    "Allow managers to view and create their client contracts and invoices": "Ermöglichen Sie Managern, ihre Kundenverträge und Rechnungen anzuzeigen und zu erstellen",
    "Allow members to view and create their client invoices": "Ermöglichen Sie Mitgliedern, ihre Kundenrechnungen anzuzeigen und zu erstellen",
    "Allow members to view their client invoices": "Ermöglichen Sie Mitgliedern, ihre Kundenrechnungen einzusehen",
    "Allow only owners to add and update products": "Erlauben Sie nur Eigentümern, Produkte hinzuzufügen und zu aktualisieren",
    "Allow members to send invoices to clients": "Allow members to send invoices to clients",
    "Allow members to confirm their client invoice rows": "Ermöglichen Sie Mitgliedern, ihre Kundenrechnungszeilen zu bestätigen",
    "Send PDF invoice": "PDF-Rechnung senden",
    "Invoice email": "Rechnungs-E-Mail",
    "Default rounding": "Standard-Rundung",
    "Round all times up to x": "Runde alle Zeiten auf x auf",
    "Time rounding increment": "Zeit Rundungsinkrement",
    "Apply time rounding to": "Zeitrundung anwenden auf",
    "Default configuration": "Standardkonfiguration",
    "Invoice date": "Rechnungsdatum",
    "Invoice entry date": "Eingangsdatum der Rechnung",
    "Bill tracked time by": "Bill verfolgte die Zeit durch",
    "Bill task field by": "Aufgabenfeld berechnen durch",
    "Create one invoice merging invoices from the same period": "Eine Rechnung erstellen, die Rechnungen aus demselben Zeitraum zusammenfasst",
    "Invoices from the same period": "Rechnungen aus dem gleichen Zeitraum",
    "Hide zero sum lines": "Nullsummenlinien ausblenden",
    "By default, time entry is billable": "Standardmäßig ist die Zeiterfassung abrechenbar",
    "Invoice number": "Rechnungsnummer",
    "Prefix": "Präfix",
    "Suffix": "Suffix",
    "Google Gmail": "Google Gmail",
    "Microsoft Outlook": "Microsoft Outlook",
    "Billing settings saved": "Abrechnungseinstellungen gespeichert",
    "billing_app_overview_text": "<p class='title'>Speed up your client billing process with flexible price lists and smart contracts.</p><div class='body-2'><p>Automate your invoicing process and save valuable time from generating invoices. Uku dynamic billing creates all your invoices based on the work done and helps you to earn fair profit from your clients. No more data collection from different softwares or excel sheets - Uku has it all and puts together invoices for you. All left for you to do is scan through the invoices and send them out.</p><p>Uku billing:</p><p><ul><li><b>Saves time</b> by reducing administrative working hours</li><li><b>Increases revenue</b> by preparing invoices based on all work done</li><li><b>Reduces error rates / avoids incorrect invoicing</b> by minimising human intervention</li><li><b>Ensures steady revenue stream</b> with more timely billing</li><li><b>Increases transparency</b> thanks to detailed and easily accessible customer agreements</li><li><b>Increases accuracy</b> by remembering all contract changes from day 1</li><li><b>Allows flexibility, scalability</b> and provides better customer experience for your client</li></ul></p><p>Uku supports all kinds of pricing models - whatever agreements you have made with your clients, we got your back. Uku invoicing allows you to create products including:</p><p><ul><li>Hourly pricing (e.g accountant price, assistant price)</li><li>Fixed fee pricing (e.g packages, annually agreed price)</li><li>Value based pricing (e.g perceived value of service(s))</li><li>Volume of work based pricing (e.g amount of documents processed)</li><li>Additional services pricing (e.g annual accounts, consultation)</li><li>Combination of several models (e.g fixed fee pricing + extra hours worked; volume of work + consultation hours; etc.)</li></ul></p><p>After the invoices have been created by Uku, you can review them, make changes (if necessary) and send them all out in bulk.</p><p><a href='http://help.getuku.com/en/articles/5716548-how-does-billing-work-in-uku' taget='_blank'>Learn more about Uku billing here.</a> </p><p>If you want to implement Uku billing and would like to have a consultation with our expert, please <a href='https://calendly.com/getuku/uku-billing' target='_blank'>book a time here</a> (free of charge).</p></div>",
    "Products": "Produkte",
    "Contract templates": "Vertragsvorlagen",
    "Invoice templates": "Rechnungsvorlagen",
    "Tools": "Tools",
    "Replace tax": "Ersetzen Sie die Steuer",
    "Old tax": "Alte Steuer",
    "New tax": "Neue Steuer",
    "Find tax": "Steuer finden",
    "Replace VAT in products": "MWSt. für Produkte ersetzen",
    "Replace VAT in master contracts": "MWSt. in Vertragsvorlagen ersetzen",
    "Replace VAT in client contracts & draft invoices": "MWSt. in Kundenverträgen und Rechnungsentwürfen ersetzen",
    "Replace VAT values": "MWSt. ersetzen",
    "This action cannot be undone": "Aktion kann nicht rückgängig gemacht werden",
    "Replace": "Ersetzen",
    "Result": "Resultat",
    "PDF templates": "PDF-Vorlagen",
    "E-mail templates": "E-Mail-Vorlagen",
    "Edit PDF template": "PDF-Vorlage bearbeiten",
    "Import classificators": "Klassifikatoren importieren",
    "products": "Produkte",
    "product": "Produkt",
    "Product / service": "Produkt / Dienstleistung",
    "Calculate": "Berechnung",
    "Article": "Artikel",
    "Resource": "Ressource",
    "Cost center": "Kostenstelle",
    "Taxes": "Steuern",
    "Code": "Code",
    "Source": "Quelle",
    "Articles": "Artikel",
    "Resources": "Ressourcen",
    "Cost centers": "Kostenstellen",
    "Units": "Einheiten",
    "Unit": "Einheit",
    "Bank accounts": "Bankkonten",
    "Bank account": "Bankkonto",
    "Bank name": "Bank Name",
    "IBAN": "WIR GEHEN",
    "SWIFT code": "SWIFT-Code",
    "Do you wish to import only new data or also overwrite existing?": "Willst du nur neue Daten importieren oder auch bestehende überschreiben?",
    "Only new": "Nur neue",
    "New items will be added. Existing ones will remain unchanged by import.": "Es werden neue Artikel hinzugefügt. Bestehende Artikel bleiben beim Import unverändert.",
    "Import everything": "Alles importieren",
    "Connect accounting service": "Buchhaltungsdienst anschließen",
    "Service": "Service",
    "API ID": "API-ID",
    "API key": "API-Schlüssel",
    "Company Account Id": "Firmenkonto-ID",
    "Api secret": "API-Geheimnis",
    "E-conomic": "E-conomic",
    "SmartAccounts": "SmartAccounts",
    "Test": "Prüfen",
    "Lock time entries": "Zeiteinträge sperren",
    "Owner rights": "Eigentümerrechte",
    "Disable company settings edit for all members": "Bearbeiten der Unternehmenseinstellungen für alle Mitglieder deaktivieren",
    "Disable personal clients for members": "Persönliche Clients für Mitglieder deaktivieren",
    "Show member birthdays": "Geburtstage der Mitglieder anzeigen",
    "Show contact birthdays": "Kontaktgeburtstage anzeigen",
    "Weekly @ Sun {0}": "Wöchentlich @ So. {0}",
    "Monthly @ last day of month": "Monatlich am letzten Tag des Monats",
    "Company event list": "Veranstaltungsliste des Unternehmens",
    "How long?": "Wie lange?",
    "Invoice no.": "Rechnungsnr.",
    "Login options": "Anmeldeoptionen",
    "Tenant ID (optional)": "Mieter-ID (optional)",
    "Add Active Directory tenant ID, if only users belonging to this tenant are allowed to connect": "Fügen Sie die Active Directory-Mandanten-ID hinzu, wenn nur Benutzer, die zu diesem Mandanten gehören, eine Verbindung herstellen dürfen",
    "How to find ID’s?": "Wie finde ich Ausweise?",
    "Microsoft connected": "Microsoft verbunden",
    "Google connected": "Google verbunden",
    "Edit company": "Firma bearbeiten",
    "Timezone": "Zeitzone",
    "VAT number": "USt-IdNr.",
    "Company number": "Handelsregisternummer",
    "Subscription plan": "Abonnementplan",
    "Payment failed": "Zahlung fehlgeschlagen",
    "Retry payment": "Wiederholen Sie die Zahlung",
    "Next payment": "Nächste Zahlung",
    "Update payment method": "Zahlungsmethode aktualisieren",
    "Plan": "Planen",
    "Choose a plan": "Wählen Sie einen Plan",
    "Change plan": "Plan ändern",
    "{0}-day free trial until {1}": "{0}-Tag kostenlos testen bis {1}",
    "monthly": "monatlich",
    "yearly": "jährlich",
    "{0} member": "{0} Mitglied",
    "{0} members": "{0} Mitglieder",
    "{0} plan": "{0} planen",
    "Cancelled (valid until {0})": "Storniert (gültig bis {0})",
    "Your trial expired on {0}": "Deine Probezeit ist am {0} abgelaufen",
    "Your subscription expired on {0}": "Dein Abonnement ist am {0} abgelaufen",
    "It’s nice to see you! If you'd like to get up and running with a Uku subscription, click Choose a plan": "Schön, dass du da bist! Wenn du ein Uku-Abonnement abschließen möchtest, klicke auf Plan wählen",
    "Save {0} by paying for a year!": "Sparen Sie {0}, indem Sie ein Jahr lang bezahlen!",
    "Choose plan": "Wählen Sie einen Plan",
    "Pay annually": "Zahlen Sie jährlich",
    "Instructions sent!": "Anleitung gesendet!",
    "Instructions for resetting your password have been sent to": "Anweisungen zum Zurücksetzen Ihres Passworts wurden an gesendet",
    "You’ll receive this email within 5 minutes. Be sure to check your spam folder, too.": "Sie erhalten diese E-Mail innerhalb von 5 Minuten. Überprüfen Sie unbedingt auch Ihren Spam-Ordner.",
    "Back to login page": "Zurück zur Anmeldeseite",
    "Get new password": "Bekomme ein neues Passwort",
    "Pick a password": "wähle ein Passwort",
    "Use minimum 8 characters with letters & numbers": "Verwenden Sie mindestens 8 Zeichen mit Buchstaben und Zahlen",
    "Create your Uku Account": "Erstellen Sie Ihr Uku-Konto",
    "Connect your Xero Account": "Verbinden Sie Ihr Xero-Konto",
    "Phone": "Telefon",
    "I agree to the": "Ich stimme dem zu",
    "Terms of Service": "Nutzungsbedingungen",
    "Next": "Nächste",
    "Having trouble?": "Probleme haben?",
    "We can help": "Wir können helfen",
    "Log in instead": "Melden Sie sich stattdessen an",
    "No. 1 tool for accounting practices. Automated workflows, time tracking, reports, monitoring, CRM. Get work done on time & profitably. Try for free!": "Das Nr. 1-Tool für Buchhaltungspraktiken. Automatisierte Arbeitsabläufe, Zeiterfassung, Berichte, Überwachung, CRM. Erledigen Sie Ihre Arbeit pünktlich und profitabel. Kostenlos testen!",
    "You are invited to join": "Sie sind herzlich eingeladen, mitzumachen",
    "Accept invitation": "Die Einladung annehmen",
    "Check your email": "Check deine E-Mails",
    "I sent you an email with a link to activate your account. This is important to ensure the security of your account.": "Ich habe Ihnen eine E-Mail mit einem Link zur Aktivierung Ihres Kontos gesendet. Dies ist wichtig, um die Sicherheit Ihres Kontos zu gewährleisten.",
    "Go to": "Gehe zu",
    "Need a new password?": "Brauchen Sie ein neues Passwort?",
    "Enter your e-mail address and we will send you directions for changing your password": "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen Anweisungen zur Änderung Ihres Passworts",
    "Send me instructions": "Schicken Sie mir Anweisungen",
    "Never mind, go back": "Egal, geh zurück",
    "No login options enabled. Please contact the company owner": "Keine Anmeldeoptionen aktiviert. Bitte wenden Sie sich an den Firmeninhaber",
    "Log in to Uku": "Melden Sie sich bei Uku an",
    "Forgot password?": "Passwort vergessen?",
    "Don't have account?": "Sie haben kein Konto?",
    "Create account": "Benutzerkonto erstellen",
    "Total items:": "Gesamtanzahl:",
    "Add new": "Neue hinzufügen",
    "Amount": "Menge",
    "Account created range": "Vom Konto erstellter Bereich",
    "Usage limit": "Nutzungsbeschränkung",
    "Valid until": "Gültig bis",
    "Edit help link": "Hilfelink bearbeiten",
    "New help link": "Neuer Hilfelink",
    "Name key": "Namensschlüssel",
    "Country code": "Landesvorwahl",
    "Period (months)": "Zeitraum (Monate)",
    "Account created from": "Konto erstellt von",
    "Account created until": "Konto erstellt bis",
    "Used count": "Verwendete Anzahl",
    "Sum": "Summe",
    "Create voucher": "Gutschein erstellen",
    "Edit voucher": "Gutschein bearbeiten",
    "Are you sure to delete this voucher?": "Möchten Sie diesen Gutschein wirklich löschen?",
    "row | rows": "zeile | Zeilen",
    "Add event": "Ereignis hinzufügen",
    "Are you sure you wish to delete this event?": "Sind Sie sicher, dass Sie dieses Ereignis löschen möchten?",
    "event | events": "Ereignis | Veranstaltungen",
    "Security object id": "Sicherheitsobjekt-ID",
    "Direct rights": "Direkte Rechte",
    "Computed rights": "Berechnete Rechte",
    "Add link": "Link hinzufügen",
    "Are you sure you wish to delete this entry?": "Sind Sie sicher, dass Sie diesen Eintrag löschen möchten?",
    "link | links": "Link | Links",
    "Event type": "Ereignistyp",
    "Date from": "Stammen aus",
    "Date until": "Datum bis",
    "Shortened by h": "Gekürzt um h",
    "Category": "Kategorie",
    "demo | demos": "Demo | Demos",
    "Companies": "Firmen",
    "Leads": "Leads",
    "Demos": "Demos",
    "Vouchers": "Gutscheine",
    "KPI": "KPI",
    "Activity log": "Aktivitätsprotokoll",
    "Notifications": "Benachrichtigungen",
    "Me": "Mich",
    "Important notifications will appear here.": "Wichtige Benachrichtigungen werden hier angezeigt.",
    "Back": "Zurück",
    "Return to UKU": "Rückkehr zur UKU",
    "Choose plan for {0}": "Wählen Sie einen Plan für {0}",
    "First payment will be made after the end of the trial period.": "Die erste Zahlung erfolgt nach Ablauf des Testzeitraums.",
    "Members and subscription can always be changed.": "Mitglieder und Abonnement können jederzeit geändert werden.",
    "Your subscription is externally managed by Xero": "Your subscription is externally managed by Xero",
    "Select plan": "Select plan",
    "Billing period": "Abrechnungszeitraum",
    "Compare features": "Vergleichen Sie Funktionen",
    "Cancel uku subscription": "Uku-Abonnement kündigen",
    "{0} discount": "{0} Rabatt",
    "You have currently<br />{0} active member": "Sie haben derzeit<br />{0} aktives Mitglied",
    "You have currently<br />{0} active members": "Sie haben derzeit<br />{0} aktive Mitglieder",
    "Select yearly plan": "Jahresplan auswählen",
    "Select monthly plan": "Wählen Sie einen Monatsplan aus",
    "Attention!": "Aufmerksamkeit!",
    "If you want to use Uku for free then deactivate your account and continue with {0} plan": "Wenn Sie Uku kostenlos nutzen möchten, deaktivieren Sie Ihr Konto und fahren Sie mit dem {0}-Plan fort",
    "per member/month (billed yearly)": "pro Mitglied/Monat (jährliche Abrechnung)",
    "or {0} per member/month (monthly)": "oder {0} pro Mitglied/Monat (monatlich)",
    "Everything in {0}, plus:": "Alles in {0}, plus:",
    "Compare plans, feature-by-feature": "Vergleichen Sie Pläne Feature für Feature",
    "Deactivate account": "Benutzerkonto deaktivieren",
    "Are you sure to deactivate {0} account?": "Sind Sie sicher, dass Sie das Konto {0} deaktivieren?",
    "If you choose to continue with freelancer plan your company account will be deactivated. Data that is related to this company will be removed.": "Wenn Sie sich dafür entscheiden, mit dem Freelancer-Plan fortzufahren, wird Ihr Firmenkonto deaktiviert. Daten, die sich auf dieses Unternehmen beziehen, werden entfernt.",
    "Deactivate": "Deaktivieren",
    "Teamwork": "Zusammenarbeit",
    "Unlimited clients + import": "Unbegrenzte Kunden + Import",
    "Access management": "Zugriffsverwaltung",
    "Custom fields": "Benutzerdefinierte Felder",
    "Live chat support": "Live-Chat-Unterstützung",
    "AML": "AML",
    "API": "API",
    "Client Portal": "Kundenportal",
    "New!": "Neu!",
    "Custom integrations": "Benutzerdefinierte Integrationen",
    "Assisted clients import": "Unterstützter Kundenimport",
    "Tailor-made team workshop": "Maßgeschneiderter Team-Workshop",
    "Early access to features": "Frühzeitiger Zugriff auf Funktionen",
    "Pay by invoice": "Bezahlen Sie per Rechnung",
    "Dedicated account manager": "Dedizierter Account Manager",
    "Hi! Your trial is over. Please choose {0} subscription plan to continue work": "Hallo! Ihr Prozess ist beendet. Bitte wählen Sie den Abonnementplan {0}, um mit der Arbeit fortzufahren",
    "Hi! You need to upgrade {0} subscription plan to use that feature": "Hallo! Sie müssen den {0}-Abonnementplan aktualisieren, um diese Funktion nutzen zu können",
    "Waiting for the subscription to complete": "Waiting for the subscription to complete",
    "Edit VAT number": "Edit VAT number",
    "VAT": "MwSt",
    "This is subscription period amount.": "Dies ist der Betrag für die Abonnementperiode.",
    "You save yearly {0}": "Du sparst jedes Jahr {0}",
    "Add voucher": "Gutschein hinzufügen",
    "Existing credit": "Vorhandener Kredit",
    "Current payment": "Aktuelle Zahlung",
    "This is the current payment amount. Your bank also requires confirmation for the subscription period amount.": "Dies ist der aktuelle Zahlungsbetrag. Deine Bank benötigt auch eine Bestätigung für den Betrag der Abonnementperiode.",
    "Confirm subscription {0}": "Abonnement bestätigen {0}",
    "Your subscription will renew on": "Dein Abonnement wird verlängert am",
    "Thank you for believing in us!": "Danke, dass du an uns glaubst!",
    "Uku team": "Uku-Team",
    "Voucher {1} (-{0}%)": "Gutschein {1} (-{0}%)",
    "Voucher {0}": "Gutschein {0}",
    "New plan": "Neuer Plan",
    "Changed plan": "Geänderter Plan",
    "Add {0} member": "Hinzufügen {0} Mitglied",
    "Add {0} members": "{0} Mitglieder hinzufügen",
    "Remove {0} member": "{0} Mitglied entfernen",
    "Remove {0} members": "{0} Mitglieder entfernen",
    "No changes to plan": "Keine Änderungen am Plan",
    "Discount -{0}% with Yearly subscription": "Rabatt -{0} % mit Jahresabonnement",
    "Yearly discounted price (-{0}%)": "Jährlicher ermäßigter Preis (-{0}%)",
    "Subscription updated": "Abonnement aktualisiert",
    "Please wait": "Warten Sie mal",
    "Your payment failed": "Ihre Zahlung ist fehlgeschlagen",
    "Please check that you entered the data correctly or use another card": "Bitte überprüfen Sie, ob Sie die Daten korrekt eingegeben haben oder verwenden Sie eine andere Karte",
    "Try again": "Versuchen Sie es erneut",
    "Pay": "Zahlen",
    "Payment": "Zahlung",
    "Payment method updated": "Zahlungsmethode aktualisiert",
    "Edit member": "Mitglied bearbeiten",
    "First name": "Vorname",
    "Last name": "Familienname, Nachname",
    "External ID": "Externe ID",
    "Select groups": "Wählen Sie Gruppen aus",
    "Administrator": "Administrator",
    "Invite sent": "Einladen gesendet",
    "Activate member": "Mitglied aktivieren",
    "Deactivate member": "Mitglied deaktivieren",
    "Invited": "Eingeladen",
    "Paid member": "Bezahltes Mitglied",
    "Send an invitation": "Eine Einladung verschicken",
    "Limited": "Limitiert",
    "No invite, no access": "Keine Einladung, kein Zugang",
    "Free until activated": "Kostenlos bis zur Aktivierung",
    "No access, no charge": "Kein Zugang, keine Gebühr",
    "Hidden member": "Verstecktes Mitglied",
    "Edit members": "Mitglieder bearbeiten",
    "Select user": "Nutzer wählen",
    "Member will be assigned to every selected client": "Jedem ausgewählten Kunden wird ein Mitglied zugewiesen",
    "Member will be removed from all selected clients": "Das Mitglied wird von allen ausgewählten Kunden entfernt",
    "Assign user": "Benutzer zuweisen",
    "Set as primary user": "Als Hauptbenutzer festlegen",
    "Added as a default user when adding a task plan": "Beim Hinzufügen eines Aufgabenplans als Standardbenutzer hinzugefügt",
    "Remove from new tasks": "Aus neuen Aufgaben entfernen",
    "Remove from plan tasks": "Aufgaben aus dem Plan entfernen",
    "Remove": "Entfernen",
    "Admin": "Administrator",
    "Remove user": "Benutzer entfernen",
    "Assign to incomplete tasks": "Unerledigten Aufgaben zuweisen",
    "Reassign incomplete tasks": "Unerledigte Aufgaben neu zuweisen",
    "Assign to plan tasks": "Zuweisen, Aufgaben zu planen",
    "Reassign plan tasks": "Planaufgaben neu zuweisen",
    "Owner will be assigned to tasks if the removed user was the last assigned user.": "Der Besitzer wird den Aufgaben zugewiesen, wenn der entfernte Benutzer der zuletzt zugewiesene Benutzer war.",
    "Run integration": "Führen Sie die Integration aus",
    "Run": "Laufen",
    "Integration configuration": "Integrationskonfiguration",
    "Read the manual": "Lesen Sie das Handbuch",
    "Api key": "API-Schlüssel",
    "Are you sure to delete this integration info?": "Sind Sie sicher, dass Sie diese Integrationsinformationen löschen?",
    "Edit Contracts": "Verträge bearbeiten",
    "Replace following contracts": "Ersetzen Sie folgende Verträge",
    "Append services to following contracts": "Hängen Sie Leistungen an folgende Verträge an",
    "Choose template": "Vorlage wählen",
    "Append only": "Nur anhängen",
    "with template": "mit Vorlage",
    "All existing contracts": "Alle bestehenden Verträge",
    "All quarterly contracts": "Alle vierteljährlichen Verträge",
    "All monthly contracts": "Alle Monatsverträge",
    "All yearly contracts": "Alle Jahresverträge",
    "Next invoice number": "Nächste Rechnungsnummer",
    "Number is too big, it cannot exceed 15 digits": "Die Zahl ist zu groß und darf nicht mehr als 15 Ziffern umfassen",
    "Replace topic": "Thema ersetzen",
    "All tasks and plans with current topic will be replaced with the new selected topic.": "Alle Aufgaben und Pläne mit aktuellem Thema werden durch das neu ausgewählte Thema ersetzt.",
    "Topics replaced": "Themen ersetzt",
    "All tasks with the topic `{0}` will be replaced with `{1}`. This is not reversible. Are you sure?": "Alle Aufgaben mit dem Thema „{0}“ werden durch „{1}“ ersetzt. Dies ist nicht umkehrbar. Bist du dir sicher?",
    "Name of topic": "Name des Themas",
    "Change topic": "Thema wechseln",
    "Add new topic": "Neues Thema hinzufügen",
    "This topic is in use. Do you wish to archive it?": "Dieses Thema wird verwendet. Möchten Sie es archivieren?",
    "Are you sure that you want to delete this topic?": "Sind Sie sicher, dass Sie dieses Thema löschen möchten?",
    "These items will be deleted permanently": "Diese Elemente werden dauerhaft gelöscht",
    "Are you sure that you want to delete this client group?": "Sind Sie sicher, dass Sie diese Kundengruppe löschen möchten?",
    "This client group is in use. Do you wish to archive it?": "Diese Clientgruppe wird verwendet. Möchten Sie es archivieren?",
    "Edit client group": "Kundengruppe bearbeiten",
    "New client group": "Neue Kundengruppe",
    "Price": "Preis",
    "Quantity": "Menge",
    "Unit will be translated to client language": "Die Einheit wird in die Sprache des Kunden übersetzt",
    "Pick date & time": "Wählen Sie Datum und Uhrzeit",
    "Share equally": "Gleichmäßig teilen",
    "Change existing": "Vorhandenes ändern",
    "Choose bookmark": "Wählen Sie Lesezeichen",
    "New title": "Neuer Titel",
    "Set as my default view": "Als meine Standardansicht speichern",
    "Signature name": "Signature name",
    "Layout": "Layout",
    "Top": "Top",
    "Middle": "Middle",
    "Bottom": "Bottom",
    "Default signature": "Default signature",
    "Max. dimensions 130 x 130 px": "Max. dimensions 130 x 130 px",
    "Logo left": "Logo left",
    "Logo top": "Logo top",
    "No logo": "No logo",
    "Linkedin": "Linkedin",
    "Facebook": "Facebook",
    "Email signature": "Email signature",
    "Edit email signature": "Edit email signature",
    "Add email signature": "Add email signature",
    "Font color": "Font color",
    "Actions": "Aktionen",
    "Delete signature": "Delete signature",
    "Do you wish to update related contracts and invoices?": "Möchten Sie zugehörige Verträge und Rechnungen aktualisieren?",
    "Update contract templates, active contracts and open invoices.": "Aktualisieren Sie Vertragsvorlagen, aktive Verträge und offene Rechnungen.",
    "The following fields will be updated": "Die folgenden Felder werden aktualisiert",
    "Custom Value": "Benutzerdefinierten Wert",
    "This product is in use. Do you wish to archive it?": "Dieses Produkt ist im Einsatz. Möchten Sie es archivieren?",
    "Are you sure that you want to delete this product?": "Sind Sie sicher, dass Sie dieses Produkt löschen möchten?",
    "Customize for client": "Für den Kunden anpassen",
    "Customize for template": "Für Vorlage anpassen",
    "Open product template": "Produktvorlage öffnen",
    "Create product template": "Produktvorlage erstellen",
    "Master template": "Master-Vorlage",
    "Client product": "Kundenprodukt",
    "Client product / service": "Kundenprodukt / Dienstleistung",
    "New client product": "Neues Kundenprodukt",
    "Template product": "Vorlage Produkt",
    "Template product / service": "Vorlage Produkt/Dienstleistung",
    "New template product": "Neue Vorlage Produkt",
    "Edit translations": "Übersetzungen bearbeiten",
    "Billable topics": "Abrechenbare Themen",
    "Billable time": "Abrechnungsfähige Zeit",
    "Minimum quantity": "Mindestmenge",
    "Minimum time": "Mindestzeit",
    "Integration parameters": "Integrationsparameter",
    "Empty values will use product default": "Bei leeren Werten wird der Produktstandard verwendet",
    "Pricing": "Preisgestaltung",
    "DC %": "Rab. %",
    "Sum all matching rows": "Summiere alle übereinstimmenden Zeilen",
    "When enabled, total price is a cumulative sum of all matching rows. By default, total price price only uses the highest matching row.": "Wenn diese Option aktiviert ist, ist der Gesamtpreis eine kumulative Summe aller übereinstimmenden Zeilen. In der Standardeinstellung wird für den Gesamtpreis nur die höchste übereinstimmende Zeile verwendet.",
    "Prices since": "Preise seitdem",
    "Add price": "Preis hinzufügen",
    "Add pricing period": "Preiszeitraum hinzufügen",
    "Update contracts": "Verträge aktualisieren",
    "(Without topic)": "(Ohne Thema)",
    "Fixed price": "Festpreis",
    "Product": "Produkt",
    "Event created": "Veranstaltung erstellt",
    "Project created": "Projekt erstellt",
    "Event deleted": "Veranstaltung gelöscht",
    "Project deleted": "Projekt gelöscht",
    "Workflow added": "Workflow hinzugefügt",
    "Workflow removed": "Workflow entfernt",
    "Workflow updated": "Arbeitsablauf aktualisiert",
    "Event cancelled": "Termin abgesagt",
    "Project cancelled": "Projekt gestrichen",
    "Event reactivated": "Ereignis reaktiviert",
    "Project reactivated": "Projekt reaktiviert",
    "Event archived": "Veranstaltung archiviert",
    "Project archived": "Projekt archiviert",
    "Event unarchived": "Ereignis nicht archiviert",
    "Project unarchived": "Projekt nicht archiviert",
    "Event changed": "Ereignis geändert",
    "Project changed": "Projekt geändert",
    "Event status changed: {0}": "Ereignisstatus geändert: {0}",
    "Project status changed: {0}": "Projektstatus geändert: {0}",
    "Event status changed": "Ereignisstatus geändert",
    "Project status changed": "Projektstatus geändert",
    "Task created": "Aufgabe erstellt",
    "Task changed": "Aufgabe geändert",
    "Task finished": "Aufgabe erledigt",
    "Task not finished": "Aufgabe nicht abgeschlossen",
    "Task deleted": "Aufgabe gelöscht",
    "Add project": "Projekt hinzufügen",
    "Hide filters": "Filter ausblenden",
    "Show filters": "Filter anzeigen",
    "Cancel event": "Ereignis abbrechen",
    "Cancel project": "Projekt abbrechen",
    "Manage event fields": "Ereignisfelder verwalten",
    "Manage project fields": "Projektfelder verwalten",
    "New event": "Neue Veranstaltung",
    "New project": "Neues Projekt",
    "{0} (Copy)": "{0} (Kopieren)",
    "Are you sure you wish to delete this project?": "Sind Sie sicher, dass Sie dieses Projekt löschen möchten?",
    "Are you sure to archive this event?": "Bist du sicher, dass du dieses Ereignis archivieren willst?",
    "Are you sure to archive this project?": "Möchten Sie dieses Projekt wirklich archivieren?",
    "Are you sure to cancel this event?": "Bist du sicher, dass du diese Veranstaltung absagen willst?",
    "Are you sure to cancel this project?": "Sind Sie sicher, dass Sie dieses Projekt abbrechen?",
    "Communication": "Kommunikation",
    "Log": "Protokoll",
    "Create event workflow": "Ereignis-Workflow erstellen",
    "Create project workflow": "Projekt-Workflow erstellen",
    "Use workflow templates to set up tasks effectively or": "Verwende Workflow-Vorlagen, um Aufgaben effektiv einzurichten oder",
    "Add tasks manually": "Fügen Sie Aufgaben manuell hinzu",
    "Save bookmark": "Bookmark speichern",
    "Remove filters": "Filter entfernen",
    "Filter": "Filter",
    "Show multiselect": "Mehrfachauswahl anzeigen",
    "To do today": "Heute zu tun",
    "This and next month": "Diesen und nächsten Monat",
    "Last 3 months": "Letzte 3 Monate",
    "Next 3 months": "Nächste 3 Monate",
    "Starts": "Beginnt",
    "To do": "Machen",
    "today": "Heute",
    "tomorrow": "morgen",
    "yesterday": "gestern",
    "Previous week": "Letzte Woche",
    "Group similar tasks": "Gruppieren Sie ähnliche Aufgaben",
    "Group by client": "Nach Kunden gruppieren",
    "Group by date": "Nach Datum gruppieren",
    "Group by topic": "Nach Thema gruppieren",
    "Your details": "Deine Details",
    "City": "Stadt",
    "Regional format": "Regionales Format",
    "Default company": "Standardunternehmen",
    "Lock time entries notification": "Benachrichtigung über Sperrzeiteinträge",
    "Notify by": "Benachrichtigen Sie per",
    "Delete my account": "Mein Konto löschen",
    "Attention": "Aufmerksamkeit",
    "Are you sure that you want to delete your account?": "Sind Sie sicher, dass Sie Ihr Konto löschen möchten?",
    "Notification": "Benachrichtigung",
    "Notification & email": "Benachrichtigungsemail",
    "Vacations / absence": "Urlaub / Abwesenheit",
    "Edit balance": "Gleichgewicht bearbeiten",
    "View history": "Siehe Verlauf",
    "Request": "Anfrage",
    "How long": "Wie lang",
    "Requested": "Angefordert",
    "Approved": "Genehmigt",
    "Rejected": "Abgelehnt",
    "In review": "Im Rückblick",
    "Change": "Ändern",
    "Agreements": "Vereinbarungen",
    "New agreement": "Neue Vereinbarung",
    "Change agreement": "Vereinbarung ändern",
    "Stop demo": "Stoppen Sie die Demo",
    "Show": "Zeigen",
    "Don't show": "Nicht zeigen",
    "Don't send": "Nicht senden",
    "Email workdays at 7 AM": "E-Mail werktags um 7 Uhr",
    "Email at 3 PM": "E-Mail um 15:00 Uhr",
    "Email at once": "Sofort per E-Mail versenden",
    "Email Sundays at 11 PM": "E-Mail sonntags um 23:00 Uhr",
    "First day of the month": "Erster Tag des Monats",
    "to email": "eine E-Mail schicken",
    "E-mail at once": "Sofort eine E-Mail senden",
    "System": "System",
    "Person": "Person",
    "Picture": "Bild",
    "Time zone": "Zeitzone",
    "Calendar settings": "Kalendereinstellungen",
    "Public holidays": "Feiertage",
    "Tax deadlines": "Steuerfristen",
    "News": "Nachricht",
    "External services": "Externe Dienste",
    "Google log in": "Google-Anmeldung",
    "Microsoft log in": "Melden Sie sich bei Microsoft an",
    "Are you sure to remove microsoft?": "Sind Sie sicher, Microsoft zu entfernen?",
    "Agreement": "Vereinbarung",
    "Active agreement": "Aktive Vereinbarung",
    "Weekly hours": "Wöchentliche Stunden",
    "Are you sure to remove google?": "Möchten Sie Google wirklich entfernen?",
    "Edit supplier": "Lieferant bearbeiten",
    "New supplier": "Neuer Lieferant",
    "Are you sure you wish to delete this supplier?": "Sind Sie sicher, dass Sie diesen Lieferanten löschen möchten?",
    "Add supplier": "Lieferant hinzufügen",
    "Supplier types are not defined. Please go to the suppliers app settings to add.": "Lieferantentypen sind nicht definiert. Bitte gehen Sie zum Hinzufügen zu den App-Einstellungen des Lieferanten.",
    "No members yet": "Noch keine Mitglieder",
    "Edit group": "Gruppe bearbeiten",
    "Add group": "Gruppe hinzufügen",
    "Are you sure to delete this user group?": "Möchten Sie diese Benutzergruppe wirklich löschen?",
    "Get set up to work with team": "Bereiten Sie sich auf die Zusammenarbeit im Team vor",
    "Company account allows you to use tools for teams, get deeper insights etc. Raise the quality of your team's workflow and lead a more profitable business.": "Mit dem Unternehmenskonto können Sie Tools für Teams nutzen, tiefere Einblicke gewinnen usw. Erhöhen Sie die Qualität des Arbeitsablaufs Ihres Teams und führen Sie ein profitableres Unternehmen.",
    "Create company account": "Firmenkonto erstellen",
    "By creating a company account you activate Uku free subscription for {0} days.": "Durch die Erstellung eines Firmenkontos aktivieren Sie das kostenlose Uku-Abonnement für {0} Tage.",
    "You have invited {0}/{1} members": "Sie haben {0}/{1} Mitglieder eingeladen",
    "Upgrade": "Aktualisierung",
    "Resend invite": "Einladung erneut senden",
    "Send invite": "Einladung senden",
    "View profile": "Profil anzeigen",
    "To add members to your team, you'll need to create a company account": "Um Mitglieder zu Ihrem Team hinzuzufügen, müssen Sie ein Unternehmenskonto erstellen",
    "Export": "Export",
    "Re-invite sent": "Wiedereinladung gesendet",
    "View report": "Zeige Bericht",
    "Member {0} will be deactivated.": "Mitglied {0} wird deaktiviert.",
    "Please select new member who will replace {0}.": "Bitte wählen Sie ein neues Mitglied aus, das {0} ersetzen wird.",
    "Select new member": "Neues Mitglied auswählen",
    "NB! Deactivation process cannot be reversed": "ACHTUNG! Der Deaktivierungsvorgang kann nicht rückgängig gemacht werden",
    "Magic button settings": "Magic-Button-Einstellungen",
    "Create only one task per month": "Erstellen Sie nur eine Aufgabe pro Monat",
    "Current month's tasks": "Aufgaben des aktuellen Monats",
    "extra work": "Extra Arbeit",
    "Without topic": "Ohne Thema",
    "Week": "Woche",
    "Previous month": "Vorheriger Monat",
    "task | tasks": "Aufgabe | Aufgaben",
    "Assign to": "Zuweisen",
    "Mark as done": "als erledigt markieren",
    "Last": "Zuletzt",
    "Snooze": "Schlummern",
    "1 dependency": "1 Abhängigkeit",
    "{0} dependencies": "{0} Abhängigkeiten",
    "Client request": "Kundenanfrage",
    "Unread notification emails": "Unread notification emails",
    "Unread internal comments": "Unread internal comments",
    "Add comment": "Einen Kommentar hinzufügen",
    "Internal comment": "Interner Kommentar",
    "Portal message": "Portalnachricht",
    "Public message means that clients can read it and the client portal will notify them by email": "Öffentliche Nachricht bedeutet, dass die Kunden sie lesen können und das Kundenportal sie per E-Mail benachrichtigt",
    "Type a comment": "Geben Sie einen Kommentar ein",
    "Send portal message": "Portalnachricht senden",
    "Open timesheet": "Stundenzettel öffnen",
    "Pause timer": "Pausenzeiten",
    "Mark undone": "Markierung rückgängig gemacht",
    "Digitise": "Digitalisieren",
    "Documents sent to digitisation": "Dokumente zur Digitalisierung geschickt",
    "Followers": "Anhänger",
    "Start / Due date": "Beginn/Fälligkeitsdatum",
    "Select topic": "Thema auswählen",
    "1 document": "1 Dokument",
    "{0} documents": "{0} Dokumente",
    "Download": "Herunterladen",
    "Download all": "Alles herunterladen",
    "Assign as task": "Als Aufgabe zuweisen",
    "When selected, the task is sent as a task to the client": "Bei Auswahl wird die Aufgabe an den Client gesendet",
    "Auto finish": "Automatisches Finish",
    "When selected, the task is marked done after client finishes it": "Wenn diese Option ausgewählt ist, wird die Aufgabe als erledigt markiert, nachdem der Kunde sie abgeschlossen hat",
    "Add comment / message": "Kommentar/Nachricht hinzufügen",
    "Add email": "E-Mail hinzufügen",
    "Add estimation": "Schätzung hinzufügen",
    "Add task field": "Aufgabenfeld hinzufügen",
    "Add dependency": "Abhängigkeit hinzufügen",
    "Drop files to upload": "Legen Sie Dateien zum Hochladen ab",
    "Task sent to client portal": "Aufgabe an das Kundenportal gesendet",
    "Task no longer assigned to client portal": "Aufgabe ist nicht mehr dem Kundenportal zugeordnet",
    "Save recurring task": "Speichern Sie wiederkehrende Aufgaben",
    "Add to-do list": "To-Do-Liste hinzufügen",
    "Waiting for event status: {0}": "Wartet auf den Ereignisstatus: {0}",
    "Waiting for project status: {0}": "Ich warte auf den Projektstatus: {0}",
    "Edit template task": "Vorlagenaufgabe bearbeiten",
    "Create recurring task": "Erstellen Sie eine wiederkehrende Aufgabe",
    "Make a copy": "Eine Kopie machen",
    "Add topic": "Thema hinzufügen",
    "Delete task": "Aufgabe löschen",
    "Delete task template": "Aufgabenvorlage löschen",
    "Select task field": "Aufgabenfeld auswählen",
    "No custom fields available for this client": "Für diesen Kunden sind keine benutzerdefinierten Felder verfügbar",
    "task": "Aufgabe",
    "recurring task": "wiederkehrende Aufgabe",
    "Do you intend to remove yourself from {0} or you want to delete it completely?": "Beabsichtigen Sie, sich aus {0} zu entfernen, oder möchten Sie es vollständig löschen?",
    "This {1} is shared with {0}": "Dieses {1} wird mit {0} geteilt",
    "Remove only me": "Nur mich entfernen",
    "Time has been tracked to this task.": "Die Zeit wurde für diese Aufgabe erfasst.",
    "Are you sure to delete this task?": "Aufgabe wirklich löschen?",
    "Undefined": "Nicht definiert",
    "COPY": "KOPIEREN",
    "On task due date": "Am Fälligkeitsdatum der Aufgabe",
    "{0} day before": "{0} Tag vorher",
    "{0} days before": "{0} Tage vorher",
    "Edit workflow": "Workflow bearbeiten",
    "Duplicate project": "Doppeltes Projekt",
    "Reset layout": "Layout zurücksetzen",
    "Any time": "Jederzeit",
    "Assign user...": "Benutzer zuweisen...",
    "1 min": "1 Minute",
    "5 min": "5 Minuten",
    "10 min": "10 Minuten",
    "30 min": "30 Minuten",
    "1 h": "1 Std",
    "Add notes": "Notizen hinzufügen",
    "Task start date": "Aufgabe Startdatum",
    "Task due date": "Fälligkeitsdatum der Aufgabe",
    "Recurrence task": "Wiederholungsaufgabe",
    "Search from one time templates": "Suche aus einmaligen Vorlagen",
    "Placeholders": "Platzhalter",
    "New task": "Neue Aufgabe",
    "New recurring task": "Neue wiederkehrende Aufgabe",
    "+1 day": "+1 Tag",
    "Edit comment": "Kommentar bearbeiten",
    "Timer is running!": "Timer läuft!",
    "Continue time from {0}": "Fortsetzungszeit ab {0}",
    "New time entry": "Neuer Zeiteintrag",
    "Load more": "Mehr laden",
    "Are you sure to delete this time entry?": "Möchten Sie diesen Zeiteintrag wirklich löschen?",
    "Save automated email": "Speichern Sie automatisierte E-Mails",
    "Automation": "Automatisierung",
    "Are you sure to delete this email?": "Möchten Sie diese E-Mail wirklich löschen?",
    "Are you sure you wish to send this email immediately?": "Sind Sie sicher, dass Sie diese E-Mail sofort senden möchten?",
    "replied to project email": "replied to project email",
    "replied to client email": "replied to client email",
    "commented": "kommentiert",
    "Reply": "Antworten",
    "Are you sure to delete this comment?": "Möchten Sie diesen Kommentar wirklich löschen?",
    "replied to client portal email": "replied to client portal email",
    "sent a message": "Nachricht ist gesendet",
    "replied to task email": "replied to task email",
    "failed to send": "Senden fehlgeschlagen",
    "sent email": "Email senden",
    "no one": "niemand",
    "created this task.": "hat diese Aufgabe erstellt.",
    "Task was automatically created from forwarded e-mail": "Task was automatically created from forwarded e-mail",
    "Task was automatically created from client portal e-mail": "Task was automatically created from client portal e-mail",
    "Task was automatically created from client e-mail": "Task was automatically created from client e-mail",
    "Task was automatically created from project e-mail": "Task was automatically created from project e-mail",
    "requested assistance.": "ist um Hilfe gebeten.",
    "updated this task.": "habe diese Aufgabe aktualisiert.",
    "tracked time to this task.": "Zeit für diese Aufgabe erfasst.",
    "finished this task.": "habe diese Aufgabe erledigt.",
    "new comment.": "neuer Kommentar.",
    "reassigned this task.": "hat diese Aufgabe neu zugewiesen.",
    "assigned the task to {0}.": "hat die Aufgabe {0} zugewiesen.",
    "reminder.": "Erinnerung.",
    "deleted.": "gelöscht.",
    "completed the task, but Uku did not auto-finish this task because not all task requirements were met.": "die Aufgabe abgeschlossen, aber Uku hat diese Aufgabe nicht automatisch beendet, weil nicht alle Anforderungen der Aufgabe erfüllt waren.",
    "sent task to client portal": "Aufgabe an Kundenportal gesendet",
    "assigned the task to client.": "hat die Aufgabe dem Kunden zugewiesen.",
    "assigned the task to company.": "hat die Aufgabe dem Unternehmen zugewiesen.",
    "added attachment(s).": "Anhänge hinzugefügt.",
    "added a comment.": "einen Kommentar hinzugefügt.",
    "added a message to {0}.": "hat eine Nachricht an {0} hinzugefügt.",
    "received a e-mail from {0}.": "received a e-mail from {0}.",
    "updated notes.": "aktualisierte Notizen.",
    "made changes to checklist.": "änderungen an der Checkliste vorgenommen.",
    "created this task template.": "hat diese Aufgabenvorlage erstellt.",
    "updated this task template.": "Diese Aufgabenvorlage wurde aktualisiert.",
    "recurring task assigned.": "wiederkehrende Aufgabe zugewiesen.",
    "recurring task deleted.": "wiederkehrende Aufgabe gelöscht.",
    "added email.": "E-Mail hinzugefügt.",
    "changed email.": "E-Mail geändert.",
    "deleted email.": "E-Mail gelöscht.",
    "sent email.": "e-Mail geschickt.",
    "failed to send.": "Senden fehlgeschlagen.",
    "added email": "E-Mail hinzugefügt",
    "changed email": "E-Mail geändert",
    "deleted email": "E-Mail gelöscht",
    "Member / Time": "Mitglied / Zeit",
    "Client/topic": "Kunde/Thema",
    "Client/task": "Kunde/Aufgabe",
    "Client/member": "Kunde/Mitglied",
    "Member/topic": "Mitglied/Thema",
    "Member/task": "Mitglied/Aufgabe",
    "Member/client": "Mitglied/Kunde",
    "Member/date": "Mitglied/Datum",
    "Date/member": "Datum/Mitglied",
    "Grouped": "Gruppiert",
    "Client/project": "Kunde/Projekt",
    "Project/member": "Projekt/Mitglied",
    "Period balance": "Periodensaldo",
    "Reset balance": "Gleichgewicht zurücksetzen",
    "Time entry has been confirmed or duration has been changed and duration will not dynamically update": "Die Zeiteingabe wurde bestätigt oder die Dauer wurde geändert und die Dauer wird nicht dynamisch aktualisiert",
    "(Without project)": "(Ohne Projekt)",
    "Decline": "Abfall",
    "Accept": "Akzeptieren",
    "Cancel decision": "Entscheidung abbrechen",
    "Accepted": "Akzeptiert",
    "Declined": "Zurückgegangen",
    "Report data has changed. Please update report.": "Berichtsdaten haben sich geändert. Bitte aktualisieren Sie den Bericht.",
    "Agreed": "Einverstanden",
    "Non billable": "Nicht abrechenbar",
    "Export report to Excel": "Bericht nach Excel exportieren",
    "By default, we export the result of the selected filters with the columns of the configured table": "Standardmäßig exportieren wir das Ergebnis der ausgewählten Filter mit den Spalten der konfigurierten Tabelle",
    "Add to export client custom fields": "Zum Exportieren benutzerdefinierter Clientfelder hinzufügen",
    "Save report": "Bericht speichern",
    "Export PDF": "PDF exportieren",
    "Export Excel": "Excel exportieren",
    "We have new version of": "Wir haben eine neue Version von",
    "Log out": "Ausloggen",
    "Previous day": "Vorheriger tag",
    "Next day": "Nächster Tag",
    "Mark all as read": "Alles als gelesen markieren",
    "Search task/client": "Aufgabe/Mandant suchen",
    "from client portal": "vom Kundenportal",
    "Hide all": "Alle ausblenden",
    "Hide for 1 hour": "Verstecken für 1 Stunde",
    "Something went wrong": "Etwas ist schief gelaufen",
    "User authentication needed": "Benutzerauthentifizierung erforderlich",
    "Invalid rights": "Ungültige Rechte",
    "The object cannot be found": "Das Objekt kann nicht gefunden werden",
    "Content too large": "Inhalt zu groß",
    "An unknown error occurred": "Ein unbekannter Fehler ist aufgetreten",
    "The action requested cannot be performed": "Die angeforderte Aktion kann nicht ausgeführt werden",
    "Go": "Gehen",
    "Actual / monitoring (month)": "Ist / Überwachung (Monat)",
    "h": "H",
    "Actual": "Tatsächlich",
    "Month": "Monat",
    "I’m setting up your account": "Ich richte Ihr Konto ein",
    "Did you know that accounting firms that have started using Uku can serve 38% more clients in the same time.": "Wussten Sie, dass Wirtschaftsprüfungsgesellschaften, die Uku nutzen, gleichzeitig 38 % mehr Kunden betreuen können?",
    "Let’s setup your company": "Lassen Sie uns Ihr Unternehmen gründen",
    "Name of your company": "Name Ihres Unternehmens",
    "Size of your team?": "Größe Ihres Teams?",
    "Which software are you using?": "Welche Software verwenden Sie?",
    "This knowledge will help us to improve Uku": "Dieses Wissen wird uns helfen, Uku zu verbessern",
    "What other software needs to be integrated?": "Welche weitere Software muss integriert werden?",
    "Book a demo": "Buchen Sie eine Demo",
    "Hi {0},": "Hallo {0},",
    "NO BOTS - ONLY HUMANS": "KEINE BOTS - NUR MENSCHEN",
    "Start a 14 day free trial": "Starten Sie eine 14-tägige kostenlose Testversion",
    "“Uku is an incredibly functional software. Uku boosted our work management and helps us provide exceptional service.”": "„Uku ist eine unglaublich funktionale Software. Uku hat unser Arbeitsmanagement gestärkt und hilft uns, außergewöhnlichen Service zu bieten.“",
    "The fastest way for you to decide if Uku can benefit {0} is a short {1} min call with our customer onboarding specialist.": "Der schnellste Weg, um herauszufinden, ob du von Uku {0} profitieren kannst, ist ein kurzes {1} minütiges Gespräch mit unserem Onboarding-Spezialisten.",
    "Hi, I'm Uku ": "Hallo, ich bin Uku",
    "I help to set up your account.": "Ich helfe Ihnen bei der Einrichtung Ihres Kontos.",
    "It only takes a minute.": "Es dauert nur eine Minute.",
    "Choose": "Wählen",
    "Your country": "Dein Land",
    "Your language": "Ihre Sprache",
    "Begin": "Start",
    "Let’s become friends": "Lass uns Freunde werden",
    "Your first name": "Ihr Vorname",
    "What is your field of work?": "Was ist Ihr Arbeitsgebiet?",
    "Your field of work": "Ihr Arbeitsgebiet",
    "How will you use Uku?": "Wie werden Sie Uku verwenden?",
    "How did you hear about Uku?": "Wie haben Sie von Uku erfahren?",
    "Choose channel": "Wählen Sie einen Kanal",
    "Please specify how you heard about us": "Bitte geben Sie an, wie Sie von uns erfahren haben",
    "Let me know Uku's new features by email": "Teilen Sie mir die neuen Funktionen von Uku per E-Mail mit",
    "Finish": "Beenden",
    "First name is required": "Vorname ist erforderlich",
    "Name is required": "Name ist erforderlich",
    "Team size is required": "Teamgröße ist erforderlich",
    "Surname is required": "Nachname ist erforderlich",
    "Field is required": "Feld ist erforderlich",
    "I will use Uku to work together with two or more teammates.": "Ich werde Uku verwenden, um mit zwei oder mehr Teamkollegen zusammenzuarbeiten.",
    "I will use Uku by myself. This plan is free, but the features are limited.": "Ich werde Uku alleine verwenden. Dieser Plan ist kostenlos, die Funktionen sind jedoch begrenzt.",
    "Media": "Medien",
    "Through integration partner": "Durch Integrationspartner",
    "Referral by friend": "Empfehlung durch einen Freund",
    "Import speeds up your clients setup, smart choice!": "Der Import beschleunigt die Einrichtung Ihrer Kunden, eine kluge Wahl!",
    "Last import: added {0}, updated {1}, skipped {2}, failed to import {3} client": "Letzter Import: {0} hinzugefügt, {1} aktualisiert, {2} übersprungen, {3} Client konnte nicht importiert werden",
    "Last import: added {0}, updated {1}, skipped {2}, failed to import {3} clients": "Letzter Import: {0} hinzugefügt, {1} aktualisiert, {2} übersprungen, {3} Clients konnten nicht importiert werden",
    "Last import: added {0}, updated {1}, skipped {2}": "Letzter Import: hinzugefügt {0}, aktualisiert {1}, übersprungen {2}",
    "What's next? Correct the data of {0} clients and upload again.": "Was kommt als nächstes? Korrigieren Sie die Daten von {0} Kunden und laden Sie sie erneut hoch.",
    "failed_to_import.xlsx": "failed_to_import.xlsx",
    "Excel (XLS, XLSX) ": "Excel (XLS, XLSX)",
    "Instead of entering clients one by one, you can use file import for a large customer base.": "Anstatt die Kunden einzeln einzugeben, können Sie den Dateiimport für einen großen Kundenstamm nutzen.",
    "Import all Merit Aktiva clients and keep client data automatically updated": "Importieren Sie alle Merit Aktiva-Kunden und halten Sie die Kundendaten automatisch auf dem neuesten Stand",
    "Ignore": "Ignorieren",
    "NEW CLIENT": "NEUER KUNDE",
    "Preview": "Vorschau",
    "Import started": "Der Import wurde gestartet",
    "Only new clients": "Nur Neukunden",
    "Update data from company register": "Daten aus dem Firmenregister aktualisieren",
    "If switched on, the company data is updated using the local business register": "Wenn aktiviert, werden die Firmendaten mithilfe des lokalen Unternehmensregisters aktualisiert",
    "We did not find a match in Äriregister": "Wir haben im Äriregister keine Übereinstimmung gefunden",
    "We did not find a match in Companies House": "Wir haben im Companies House keine Übereinstimmung gefunden",
    "No integration yet": "Noch keine Integration",
    "Uku match": "Uku-Match",
    "Business register nr.": "Handelsregister-Nr.",
    "Company register": "Firmenregister",
    "Upload file": "Datei hochladen",
    "Before uploading your file": "Bevor Sie Ihre Datei hochladen",
    "Learn Uku’s data structure": "Lernen Sie die Datenstruktur von Uku kennen",
    "Download and use our sample file to see exactly how we organize data in Uku": "Laden Sie unsere Beispieldatei herunter und verwenden Sie sie, um genau zu sehen, wie wir Daten in Uku organisieren",
    "Download Client Import Example": "Laden Sie das Client-Importbeispiel herunter",
    "Download Contact Import Example": "Laden Sie das Beispiel für den Kontaktimport herunter",
    "Fill in fields": "Füllen Sie die Felder aus",
    "The only mandatory field is the company name. Make sure you've filled out all the necessary fields before uploading the file.": "Das einzige Pflichtfeld ist der Firmenname. Stellen Sie sicher, dass Sie alle erforderlichen Felder ausgefüllt haben, bevor Sie die Datei hochladen.",
    "Learn more about mandatory fields": "Erfahren Sie mehr über Pflichtfelder",
    "Create custom fields": "Erstellen Sie benutzerdefinierte Felder",
    "Some data fields may not be present by default. Make sure you create these custom fields before importing your data.": "Einige Datenfelder sind möglicherweise nicht standardmäßig vorhanden. Stellen Sie sicher, dass Sie diese benutzerdefinierten Felder erstellen, bevor Sie Ihre Daten importieren.",
    "Add new custom fields": "Fügen Sie neue benutzerdefinierte Felder hinzu",
    "...or drag a file here": "...oder ziehen Sie eine Datei hierher",
    "Only Excel (.xls, .xlsx) file types are supported": "Es werden nur Excel-Dateitypen (.xls, .xlsx) unterstützt",
    "Mapping": "Kartierung",
    "First row is a header": "Die erste Zeile ist eine Kopfzeile",
    "Add field to all clients": "Feld zu allen Kunden hinzufügen",
    "Add client group": "Kundengruppe hinzufügen",
    "Fields for all clients": "Felder für alle Kunden",
    "Import of {0} in progress": "Import von {0} läuft",
    "Import in progress": "Import läuft",
    "It may take some time. You can do other activities in Uku at the same time, we will let you know when it is ready.": "Es kann einige Zeit dauern. Sie können gleichzeitig andere Aktivitäten in Uku unternehmen. Wir informieren Sie, wenn es soweit ist.",
    "Cancel import": "Import abbrechen",
    "Are you sure you want to cancel import?": "Möchten Sie den Import wirklich abbrechen?",
    "Last updated": "Letzte Aktualisierung",
    "Contracts": "Verträge",
    "Job name": "Berufsbezeichnung",
    "Workflow name": "Workflowname",
    "Details": "Einzelheiten",
    "Select jobs": "Wählen Sie Jobs aus",
    "Select task plan": "Aufgabenplan auswählen",
    "of existing client": "des bestehenden Kunden",
    "You can also choose": "Sie können auch wählen",
    "existing client tasks plan": "vorhandener Kundenaufgabenplan",
    "existing predefined jobs": "vorhandene vordefinierte Jobs",
    "create a new plan": "einen neuen Plan erstellen",
    "Select workflow": "Workflow auswählen",
    "existing project workflow": "bestehenden Projektworkflow",
    "existing workflow": "bestehenden Workflow",
    "create a new workflow": "Erstellen Sie einen neuen Workflow",
    "New tasks template": "Neue Aufgabenvorlage",
    "to save template!": "Vorlage speichern!",
    "You can also add tasks from jobs": "Sie können auch Aufgaben aus Jobs hinzufügen",
    "or choose": "oder wählen",
    "New workflow template": "Neue Workflow-Vorlage",
    "You can also add tasks from existing workflow templates": "Sie können auch Aufgaben aus vorhandenen Workflow-Vorlagen hinzufügen",
    "existing event workflow": "bestehender Event-Workflow",
    "Hide others": "Andere verstecken",
    "Update all events (New tasks)": "Alle Ereignisse aktualisieren (Neue Aufgaben)",
    "Update all projects (New tasks)": "Alle Projekte aktualisieren (Neue Aufgaben)",
    "Once": "Einmal",
    "Once a month": "Einmal pro Monat",
    "Once a quarter": "Einmal ein Viertel",
    "Once a year": "Einmal im Jahr",
    "Company workflow": "Unternehmens-Workflow",
    "Company jobs": "Firmenjobs",
    "Default jobs": "Standardjobs",
    "ID": "AUSWEIS",
    "Task title and labels": "Aufgabentitel und Beschriftungen",
    "Assigned and time": "Zugewiesen und Zeit",
    "Setup tasks for {0} event": "Aufgaben für das Ereignis {0} einrichten",
    "Setup tasks for {0} project": "Aufgaben für das Projekt {0} einrichten",
    "New job": "Neue Arbeit",
    "Edit job": "Auftrag bearbeiten",
    "New workflow": "Neuer Arbeitsablauf",
    "Save workflow": "Workflow speichern",
    "Create task plan": "Aufgabenplan erstellen",
    "Confirm task plan": "Bestätigen Sie den Aufgabenplan",
    "Skip": "Überspringen",
    "Confirm workflow": "Bestätigen Sie den Workflow",
    "Client portal templates": "Vorlagen für Kundenportale",
    "Jobs": "Arbeitsplätze",
    "Workflows": "Arbeitsabläufe",
    "Company workflows": "Arbeitsabläufe im Unternehmen",
    "Default workflows": "Standard-Workflows",
    "Company template saved": "Unternehmensvorlage gespeichert",
    "Company template created": "Unternehmensvorlage erstellt",
    "Format": "Format",
    "Currency": "Währung",
    "Reference number": "Referenznummer",
    "Invoice description": "Rechnungsbeschreibung",
    "Summarize invoice rows": "Rechnungszeilen zusammenfassen",
    "Summarized description": "Zusammengefasste Beschreibung",
    "Reverse charge": "Reverse Charge",
    "Rounding": "Rundung",
    "Time rounding will apply for each line": "Die Zeit wird für jede Zeile gerundet",
    "Rounding increment (up)": "Rundungsschritt (aufwärts)",
    "Reply to": "Antwort an",
    "Configuration": "Konfiguration",
    "Invoice to parent company": "Rechnung an die Muttergesellschaft",
    "Create all invoices under parent company.": "Erstelle alle Rechnungen unter der Muttergesellschaft.",
    "User code": "Benutzercode",
    "Default": "Standard",
    "Default value will apply for each line": "Der Standardwert gilt für jede Zeile",
    "Number": "Nummer",
    "You can write any of the following in curly braces to invoice prefix field. When saving the contract the prefix is filled with the corresponding value.": "Sie können Folgendes in geschweiften Klammern in das Rechnungspräfixfeld schreiben. Beim Speichern des Vertrags wird das Präfix mit dem entsprechenden Wert gefüllt.",
    "Copy to clipboard": "In die Zwischenablage kopieren",
    "Invoice previous period": "Vorherige Periode in Rechnung stellen",
    "Invoice period": "Rechnungszeitraum",
    "Invoice next period": "Rechnung für nächste Periode",
    "Client primary user": "Hauptbenutzer des Clients",
    "Original client name": "Ursprünglicher Name des Kunden",
    "invoice date year": "Rechnungsdatum Jahr",
    "last two digits of invoice date year": "Die letzten beiden Ziffern des Rechnungsdatums und das Jahr",
    "invoice date month": "Rechnungsdatum Monat",
    "invoice date day": "Tag des Rechnungsdatums",
    "Copied to clipboard": "In die Zwischenablage kopiert",
    "Contract": "Vertrag",
    "Net total": "Net total",
    "Contract #": "Vertrag #",
    "Invoice #": "Rechnung #",
    "Exported": "Exportiert",
    "Sent": "Gesendet",
    "Net": "Netz",
    "Add invoice": "Rechnung hinzufügen",
    "Change invoice number": "Rechnungsnummer ändern",
    "Review changes": "Überprüfen Sie die Änderungen",
    "Please review and approve changes to the related events": "Bitte überprüfe und genehmige Änderungen an den zugehörigen Ereignissen",
    "Please review and approve changes to the related projects": "Bitte überprüfe und genehmige Änderungen an den entsprechenden Projekten",
    "Contains": "Enthält",
    "contains": "enthält",
    "Exactly": "Exakt",
    "is exactly": "ist genau",
    "Greater than": "Größer als",
    "is greater than": "ist größer als",
    "Less than": "Weniger als",
    "is less than": "ist weniger als",
    "Range": "Bereich",
    "is in range of": "liegt im Bereich von",
    "is empty": "ist leer",
    "Task plan": "Aufgabenplan",
    "Edit plan": "Plan bearbeiten",
    "Use task plan templates to set up tasks effectively or add a task manually": "Verwenden Sie Aufgabenplanvorlagen, um Aufgaben effektiv einzurichten oder eine Aufgabe manuell hinzuzufügen",
    "Add task manually": "Aufgabe manuell hinzufügen",
    "Quarterly": "Vierteljährlich",
    "Export excel": "Excel exportieren",
    "Print PDF": "PDF drucken",
    "Edit jobs": "Jobs bearbeiten",
    "Replace plan tasks with job": "Ersetzen Sie Planaufgaben durch Jobs",
    "Select template": "Vorlage auswählen",
    "member": "Mitglied",
    "Tasks with user will be added to every selected client": "Aufgaben mit Benutzer werden jedem ausgewählten Kunden hinzugefügt",
    "Add even if job already applied": "Hinzufügen, auch wenn die Stelle bereits vergeben ist",
    "Default user": "Standardbenutzer",
    "This will delete all tasks from client plan and put only selected template’s tasks in it": "Dadurch werden alle Aufgaben aus dem Kundenplan gelöscht und nur die Aufgaben der ausgewählten Vorlage in den Plan aufgenommen",
    "Adding template will be ready in a minute. You can continue with work.": "Das Hinzufügen einer Vorlage ist in einer Minute fertig. Sie können mit der Arbeit fortfahren.",
    "Add client": "Kunde hinzufügen",
    "Export clients": "Kunden exportieren",
    "Export client contacts": "Kundenkontakte exportieren",
    "client | clients": "Kunde | Kunden",
    "clients": "Kunden",
    "client(s) had errors": "Client(s) hatten Fehler",
    "client(s) selected": "Kunde(n) ausgewählt",
    "Contract actions": "Vertragshandlungen",
    "Edit Members": "Mitglieder bearbeiten",
    "Edit monitoring": "Überwachung bearbeiten",
    "Your company": "Ihr Unternehmen",
    "Edit billing": "Abrechnung bearbeiten",
    "Activate client portal": "Kundenportal aktivieren",
    "After activation, you can send tasks directly to all client's contacts who have an e-mail address.": "Nach der Aktivierung kannst du Aufgaben direkt an alle Kundenkontakte senden, die eine E-Mail-Adresse haben.",
    "Send welcome invitation to client contacts": "Senden Sie Willkommenseinladungen an Kundenkontakte",
    "Who will receive an invitation?": "Wer erhält eine Einladung?",
    "Client contact who has one valid e-mail address": "Kundenkontakt, der über eine gültige E-Mail-Adresse verfügt",
    "Client contact who has the client's portal open (default for all)": "Kundenkontakt, der das Kundenportal geöffnet hat (Standard für alle)",
    "How does the invitation work?": "Wie funktioniert die Einladung?",
    "Uku creates and sends a 'Welcome task' to each client contact. It's created by the client primary user based on the 'Welcome to the Customer Portal' task template. Check it out under your company task templates. It will be translated according to the contact language.": "Uku erstellt und sendet eine \"Willkommensaufgabe\" an jeden Kundenkontakt. Sie wird vom Hauptbenutzer des Kunden auf der Grundlage der Aufgabenvorlage \"Willkommen im Kundenportal\" erstellt. Sieh dir diese unter den Aufgabenvorlagen für dein Unternehmen an. Sie wird entsprechend der Sprache des Kontakts übersetzt.",
    "Uku client portal always informs clients by email about new tasks.": "Das Uku Kundenportal informiert die Kunden immer per E-Mail über neue Aufgaben.",
    "View templates": "Vorlagen anzeigen",
    "Client portal activated": "Kundenportal aktiviert",
    "Company's name": "Firmenname",
    "Mark": "Markieren",
    "Add members": "Fügen Sie Mitglieder hinzu",
    "Members and groups": "Mitglieder und Gruppen",
    "Topic is required": "Thema ist erforderlich",
    "Entering time is required": "Die Eingabe von Zeit ist erforderlich",
    "Delete client": "Mandant löschen",
    "Manage client fields": "Kundenfelder verwalten",
    "Max 3 characters": "Maximal 3 Zeichen",
    "Are you sure you wish to delete this client?": "Sind Sie sicher, dass Sie diesen Kunden löschen möchten?",
    "Deleting client data will also delete all client-related tasks.<br/><br/>NB! Client history will be deleted": "Wenn du Kundendaten löschst, werden auch alle kundenbezogenen Aufgaben gelöscht.<br/><br/>Achtung! Der Kundenverlauf wird gelöscht",
    "Owner": "Eigentümer",
    "All clients that you add under {0} will be deleted later.</div>": "Alle Clients, die Sie unter {0} hinzufügen, werden später gelöscht.</div>",
    "Use this account for testing purposes only!": "Benutzen Sie dieses Konto nur zu Testzwecken!",
    "Read more about the demo account": "Lesen Sie mehr über das Demokonto",
    "Rights": "Rechte",
    "Monitoring setup": "Überwachungseinrichtung",
    "Learn more about monitoring": "Erfahren Sie mehr über Überwachung",
    "selected": "ausgewählt",
    "Invoicing": "Fakturierung",
    "Billing template": "Abrechnungsvorlage",
    "New": "Neu",
    "Add row": "Zeile hinzufügen",
    "Delete contract": "Vertrag löschen",
    "Product / description": "Produktbeschreibung",
    "Qty": "Menge",
    "Product placeholders": "Produktplatzhalter",
    "You can write any of the following lines in curly brackets to product description. When saving an invoice it will replace the text with the corresponding value.": "You can write any of the following lines in curly brackets to product description. When saving an invoice it will replace the text with the corresponding value.",
    "Template saved": "Vorlage gespeichert",
    "Warning": "Warnung",
    "Would you like to apply these changes to all clients using this contract template?": "Möchten Sie diese Änderungen auf alle Kunden anwenden, die diese Vertragsvorlage verwenden?",
    "Yes, apply to all clients": "Ja, gilt für alle Kunden",
    "You have made changes to time period that this billing contract applies to. This may change how affected unbilled services in the past and future will be invoiced. Please confirm that this change was intentional.": "Sie haben Änderungen am Zeitraum vorgenommen, für den dieser Abrechnungsvertrag gilt. Dadurch kann sich die Art und Weise ändern, wie betroffene, nicht abgerechnete Leistungen in der Vergangenheit und Zukunft in Rechnung gestellt werden. Bitte bestätigen Sie, dass diese Änderung beabsichtigt war.",
    "Are you sure to delete this template?": "Möchten Sie diese Vorlage wirklich löschen?",
    "Save template": "Vorlage speichern",
    "Save as template": "Als Vorlage speichern",
    "Please note all changes made to contract will be lost": "Bitte beachten Sie, dass alle am Vertrag vorgenommenen Änderungen verloren gehen",
    "Add contract": "Vertrag hinzufügen",
    "Manage contract templates": "Vertragsvorlagen verwalten",
    "Change account details": "Kontodaten ändern",
    "Country is required": "Land ist erforderlich",
    "Address": "Adresse",
    "Postal code": "Postleitzahl",
    "State": "Zustand",
    "Uku is set up according to the field of work.": "Uku ist je nach Arbeitsgebiet zusammengestellt.",
    "Size of the team": "Größe des Teams",
    "Website": "Website",
    "Delete account": "Konto löschen",
    "Deleting an account will also delete all clients associated with the account, their tasks, and their entire history. Are you sure that you want to delete your account?": "Durch das Löschen eines Kontos werden auch alle mit dem Konto verknüpften Kunden, ihre Aufgaben und ihr gesamter Verlauf gelöscht. Sind Sie sicher, dass Sie Ihr Konto löschen möchten?",
    "Yes, delete the account with all related data such as clients, tasks, and all history": "Ja, löschen Sie das Konto mit allen zugehörigen Daten wie Kunden, Aufgaben und dem gesamten Verlauf",
    "These invoices cannot be sent. Check their status or error messages.": "Diese Rechnungen können nicht versendet werden. Überprüfe ihren Status oder ihre Fehlermeldungen.",
    "Please confirm that you wish to proceed.": "Bitte bestätigen Sie, dass Sie fortfahren möchten.",
    "Sending invoice | Sending invoices": "Rechnung senden | Versenden von Rechnungen",
    "You are about to e-mail this invoice to customer. | You are about to e-mail these invoices to customers.": "Sie sind dabei, diese Rechnung per E-Mail an den Kunden zu senden. | Sie sind dabei, diese Rechnungen per E-Mail an Kunden zu senden.",
    "Error in calculating invoice": "Fehler bei der Berechnung der Rechnung",
    "Error in importing invoice": "Fehler beim Importieren der Rechnung",
    "Error in creating invoice": "Fehler beim Erstellen der Rechnung",
    "Error in exporting invoice": "Fehler beim Exportieren der Rechnung",
    "Error in sending invoice": "Fehler beim Versenden der Rechnung",
    "Calculating invoice": "Rechnung berechnen",
    "Creating invoice": "Rechnung erstellen",
    "Exporting invoice": "Rechnung exportieren",
    "Importing invoice": "Rechnung importieren",
    "Sending invoice": "Rechnung senden",
    "Clear errors": "Klare Fehler",
    "Related work will be made billable again. The invoices will not be deleted from external systems, you will have to do that manually.": "Damit verbundene Arbeiten werden wieder abrechenbar gemacht. Die Rechnungen werden nicht aus externen Systemen gelöscht, Sie müssen dies manuell tun.",
    "Delete invoice | Deleting invoices": "Rechnung löschen | Rechnungen löschen",
    "Selected net total": "Selected net total",
    "Nothing in invoices": "Nichts in Rechnungen",
    "Please make sure you have setup recurring billing for your clients": "Bitte stellen Sie sicher, dass Sie eine wiederkehrende Abrechnung für Ihre Kunden eingerichtet haben",
    "Draft": "Entwurf",
    "Approval": "Genehmigung",
    "Created": "Erstellt",
    "Coming soon": "Demnächst",
    "Selected invoices and related product info will be sent to accounting system.": "Ausgewählte Rechnungen und zugehörige Produktinformationen werden an das Buchhaltungssystem gesendet.",
    "Piece": "Stück",
    "Hour": "Stunde",
    "Delete row": "Zeile löschen",
    "Out of ": "Aus",
    " can be created": "erstellt werden können",
    "For ": "Für",
    " invoicing period is still ongoing. Any work done in this period after creation of the invoice will not be invoiced.": "Der Rechnungszeitraum läuft noch. In diesem Zeitraum nach Rechnungsstellung erbrachte Leistungen werden nicht in Rechnung gestellt.",
    "Invoice date will be set to today.": "Das Rechnungsdatum wird auf heute festgelegt.",
    "Uku is about to create": "Uku ist dabei zu erschaffen",
    " selected row, only | selected row, only ": "ausgewählte Zeile, nur | Nur die ausgewählte Zeile",
    " invoice | invoices": "Rechnung | Rechnungen",
    "These invoices cannot be exported. Check their status or error messages.": "Diese Rechnungen können nicht exportiert werden. Überprüfe ihren Status oder ihre Fehlermeldungen.",
    "Exporting invoice | Exporting invoices": "Rechnung exportieren | Rechnungen exportieren",
    "You are about to export this invoice to accounting. | You are about to export these invoices to accounting.": "Sie sind dabei, diese Rechnung in die Buchhaltung zu exportieren. | Sie sind dabei, diese Rechnungen in die Buchhaltung zu exportieren.",
    "This invoice has already been exported. Are you sure you want to export it as a new invoice? | Some of these invoices have already been exported. Are you sure that you want to export them as new invoices?": "This invoice has already been exported. Are you sure you want to export it as a new invoice? | Some of these invoices have already been exported. Are you sure that you want to export them as new invoices?",
    "Download pdf": "PDF Herunterladen",
    "Create invoice": "Rechnung erstellen",
    "Update status from {0}": "Status aktualisieren von {0}",
    "Show all lines": "Alle Linien anzeigen",
    "Calculate invoice": "Rechnung berechnen",
    "Loading invoice...": "Rechnung wird geladen...",
    "Invalid Scoro credentials": "Ungültige Scoro-Anmeldeinformationen",
    "Please confirm the changes you have made to this invoice.": "Bitte bestätigen Sie die Änderungen, die Sie an dieser Rechnung vorgenommen haben.",
    "NB! Note that changed invoice will not be automatically sent to customer or exported to external systems - you will have to do this manually.": "ACHTUNG! Beachten Sie, dass geänderte Rechnungen nicht automatisch an den Kunden gesendet oder in externe Systeme exportiert werden – Sie müssen dies manuell tun.",
    "Invoice number already exists! Please confirm to save anyway.": "Rechnungsnummer existiert bereits! Bitte bestätigen Sie, um trotzdem zu speichern.",
    "Error in data": "Fehler in den Daten",
    "The invoicing period is still ongoing. Any work done in this period after creation of the invoice will not be invoiced.": "Der Rechnungszeitraum läuft noch. In diesem Zeitraum nach Rechnungsstellung erbrachte Leistungen werden nicht in Rechnung gestellt.",
    "Creation date": "Erstellungsdatum",
    "{0} days after": "{0} Tage später",
    "{0} day after": "{0} Tag danach",
    "right away when": "sofort, wenn",
    "start date": "Startdatum",
    "due date": "Geburtstermin",
    "finished": "fertig",
    "Entries count": "Einträge zählen",
    "Entries excluding sales": "Einträge ohne Verkäufe",
    "Entries excluding bank": "Einträge ohne Bank",
    "Entries excluding documents": "Einträge ohne Dokumente",
    "Documents (sales and purchases)": "Dokumente (Verkäufe und Einkäufe)",
    "Cash entries": "Bareinträge",
    "VAT entries": "Mehrwertsteuereinträge",
    "Stock entries": "Aktieneinträge",
    "Sale entries": "Verkaufseinträge",
    "Purchase entries": "Kaufeinträge",
    "Bank entries": "Bankeinträge",
    "Ledger entries": "Hauptbucheinträge",
    "Depreciation entries": "Abschreibungseinträge",
    "Entry lines count": "Es zählen die Eingabezeilen",
    "Company owner": "Firmeninhaber",
    "Activity": "Aktivität",
    "Oldest first": "Die ältesten zu erst",
    "Newest first": "Das neuste zuerst",
    "Quantity as time": "Menge als Zeit",
    "Quantity as number": "Menge als Zahl",
    "Quantity as time in number format": "Menge als Zeit im Zahlenformat",
    "No rounding": "Keine Rundung",
    "min": "Mindest",
    "hour": "Stunde",
    "Last day of month": "Letzter Tag des Monats",
    "Invoice line": "Rechnungsposition",
    "Task time total (per member)": "Aufgabenzeit insgesamt (pro Mitglied)",
    "Time entry": "Zeiteintrag",
    "Task finish date": "Datum der Beendigung der Aufgabe",
    "Create separately": "Separat erstellen",
    "Merge into one": "Zu einer Einheit verschmelzen",
    "No minimum": "Nicht das Geringste",
    "{0} minute": "{0} Minute",
    "{0} minutes": "{0} Minuten",
    "{0} hour": "{0} Stunde",
    "{0} hours": "{0} Stunden",
    "English": "Englisch",
    "Estonian": "Estnisch",
    "Danish": "Dänisch",
    "Lithuanian": "Litauisch",
    "Russian": "Russisch",
    "Finnish": "Finnisch",
    "Swedish": "Schwedisch",
    "Norwegian": "Norwegisch",
    "Latvian": "Lettisch",
    "Bulgarian": "Bulgarisch",
    "German": "Deutsch",
    "Spanish": "Spanisch",
    "Polish": "Polieren",
    "Field: ": "Feld:",
    "Normal hours": "Normale Öffnungszeiten",
    "Year": "Jahr",
    "Estonia": "Estland",
    "Finland": "Finnland",
    "Poland": "Polen",
    "Connection successful!": "Verbindung erfolgreich!",
    "User": "Benutzer",
    "None": "Keiner",
    "Error!": "Fehler!",
    "Pending": "Ausstehend",
    "Finished": "Fertig",
    "Text": "Text",
    "Choice": "Auswahl",
    "Yes/No": "Ja Nein",
    "Integer": "Ganze Zahl",
    "Multiple choice": "Mehrfachauswahl",
    "URL": "URL",
    "Multiple users": "Mehrere Benutzer",
    "Multiline text": "Mehrzeiliger Text",
    "Must be a integer": "Muss eine Ganzzahl sein",
    "Must be a date": "Muss ein Datum sein",
    "Must be a valid e-mail address": "muss eine gültige E-Mail-Adresse sein",
    "Unknown choice": "Unbekannte Wahl",
    "Some errors occurred:": "Es sind einige Fehler aufgetreten:",
    "Unknown network error": "Unbekannter Netzwerkfehler",
    "Could not connect to the service": "Es konnte keine Verbindung zum Dienst hergestellt werden",
    "Reload this page": "Lade diese Seite neu",
    "Invoice paid": "Rechnung bezahlt",
    "Annulled": "Annulliert",
    "Processing": "wird bearbeitet",
    "You are about to deactivate this app.": "Sie sind dabei, diese App zu deaktivieren.",
    "You are about to disconnect this app.": "Du bist dabei, die Verbindung zu dieser App zu trennen.",
    "Do you also want to activate billing to get the most out of Uku?": "Möchten Sie auch die Abrechnung aktivieren, um Uku optimal zu nutzen?",
    "Invoice": "Rechnung",
    "Clients - Monitoring": "Kunden – Überwachung",
    "Links": "Links",
    "New template": "Neue Vorlage",
    "Import Clients from Excel": "Importieren Sie Kunden aus Excel",
    "Importer": "Importeur",
    "Import clients from Excel": "Importieren Sie Kunden aus Excel",
    "Account settings": "Account Einstellungen",
    "Empty": "Leer",
};
export default translations